/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
// libraries
import Head from 'next/head';
import { useRouter } from 'next/router';
import { CSSProperties, useCallback, useEffect, useMemo, useRef, useState } from 'react';
// utils
import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import { useAuth } from '../../components/context/Info';
import FavoritosComponent from '../../components/fixed/favoritos/FavoritosComponent';
import WhatsAppComponent from '../../components/fixed/whatsapp/WhatsappComponent';
import WelcomePiecesCompany from '../../components/pieces/welcomeCompany/WelcomePiecesCompany';
import PopUpComponent from '../../components/popUp/PopUpComponent';
import ImoveisSchema from '../../components/screma/ImoveisSchema';
import { appendRegiaoQuery, CIDADES_QUERY_PARAM, filtraCidadesRegiao, formatCidadesQuery, parseCidadesQuery, resolveCidadesBusca } from '../../lib/region';
import { getImoveisListServerSideProps } from '../../lib/server/site-props';
import { propertiesFilter, propertiesFilterPromocao, propertiesFilterWithMap, propertiesFilterPromocaoWithMap, propertiesMapa, propertiesMapaPromocao } from '../../services/properties';
import { allCaracteristicas, allDatasEntrega, categorias, district, get_estados, getCompany } from '../../services/selectors';
import FaixaBuscaIa from '../../components/pieces/welcome-ia/FaixaBuscaIa';
import {
    buscaIaAtiva,
    CampoMinimoIa,
    DadosFaixaBuscaIa,
    ExtrasBuscaIa,
    lerFaixaBuscaIa,
    lerParametrosBuscaIa,
    MINIMOS_BUSCA_IA,
    minimosIaEfetivos,
    ORDEM_DISTANCIA,
    ParametrosBuscaIa,
    parametrosBuscaIaVazios,
    queryBuscaIa,
    rotuloMinimoIa,
    rotuloOrdemDistancia,
    salvarFaixaBuscaIa,
    temMinimosIa,
} from '../../utils/buscaIa';
import { apenasArray, ensureReadableTextColor, formatCaracteristicas, formatSelects, formatSelectsTransacao, isColorLight, removerAcentos, rotulosHifen, segmentoFiltroCasaNome, segmentoFiltroSeguro, slugSegmentoFiltro } from '../../utils/FunctionsGlobals';
import { hifenUrl } from '../../utils/hifenUrl';
import { ehModeloHorizonte, hexParaRgba } from '../../components/pieces/horizonte/horizonte';
import { ehModeloAurora, varsAurora } from '../../components/pieces/aurora/aurora';
import { ehModeloPanorama, varsPanorama } from '../../components/pieces/panorama/panorama';
import { ehModeloLarissa, tituloEmDoisTons, varsLarissaInterna } from '../../components/pieces/larissa/larissa';
import { ehModeloInternacional, paletaInternacional, varsInternacionalPagina } from '../../components/pieces/internacional/internacionalInternas';
import inInterna from '../../components/pieces/internacional/InternacionalInterna.module.css';
import { ehModeloNorte, paletaNorte, varsNortePagina } from '../../components/pieces/norte/norteInternas';
import ntInterna from '../../components/pieces/norte/NorteInterna.module.css';
import '../../components/pieces/norte/NorteFonte.module.css';
import { ehModeloCampo, paletaCampo, varsCampoPagina } from '../../components/pieces/campo/campoInternas';
import cpInterna from '../../components/pieces/campo/CampoInterna.module.css';
import '../../components/pieces/campo/CampoFonte.module.css';
import { ehModeloMetropole, varsMetropoleInterna } from '../../components/pieces/metropole/metropole';
import { carregarEstadosComPais, cidadesDoPais, getEstadosComPaisStorageKey, idsCidadesDoPais, listarPaises, PAIS_QUERY_PARAM, resolverPaisEstado, temFiltroPais } from '../../utils/filtroPais';
import { filtrarTiposDoSelect } from '../../utils/tiposBuscaOcultos';
import { qtdMultiDaUrl, qtdMultiNoSite, qtdParaBusca, qtdParaUrl, qtdTexto, qtdTextoDaUrl, temListaQtd } from '../../utils/qtdMultiSelecao';
import { appendFiltrosMultiQuery, buscaMultiSelecao, localMultiNoSite, CATEGORIAS_QUERY_PARAM, CONDOMINIOS_QUERY_PARAM, idsMultiAtivos, parseIdsQuery, uniaoBairrosDasCidades } from '../../utils/buscaMultiSelecao';
import { idsComXarasPorNome, idsDeTiposParaBusca, umTipoPorNome } from '../../utils/tiposHomonimos';
import { ordemSemMaisRecentes } from '../../utils/ordemSemMaisRecentes';
import {
    getHomeScopedStorageKey,
    getImoveisListCategoryStorageKey,
    getImoveisListCaracteristicasStorageKey,
    getImoveisListDatasStorageKey,
    getImoveisListStatesStorageKey,
    readJsonStorageValue,
} from '../../utils/homeCache';
import { buscaCidadeFixaEstrita, condominiosStorageName, filtrarCondominiosCidadeFixa } from '../../utils/condominiosBusca';
import { buildImoveisSeo, tituloListagemDoSite } from '../../utils/imoveisSeo';
import { temSeoContextoListagem, tituloListagemPorContexto } from '../../utils/seoContextoListagem';
import { genMetaEventId, resolvePixelId, sendMetaCapiEvent } from '../../utils/metaPixel';
import ListPiecesProperties, { coresListagemAP, varsListagemAP } from './components/pieces/list/ListPiecesProperties';
const AboutPieces = dynamic(() => import('../../components/pieces/about/AboutPieces'), { ssr: false });
const AboutPieces1 = dynamic(() => import('../../components/pieces/about1/AboutPieces1'), { ssr: false });
import { NEW_RODAPE } from '../../components/registry/home';
import { paginaInternaAtelier, siteComPaletaAtelier, varsAtelier } from '../../components/pieces/atelier/atelier';
import atInterna from '../../components/pieces/atelier/AtelierInterna.module.css';
const AboutPieces2 = dynamic(() => import('../../components/pieces/about1/AboutPieces2'), { ssr: false });
const MegaFooter = dynamic(() => import('../../components/pieces/mega-footer/MegaFooter'), { ssr: false });
const EditorialFooter = dynamic(() => import('../../components/pieces/editorial-footer/EditorialFooter'), { ssr: false });
import { getWithTTL, setWithTTL } from '../../utils/storage';
import styles from './Properties.module.css';

export const getServerSideProps = getImoveisListServerSideProps;

const Properties = () => {
    // constants
    const {
        allDataHome,
        favorito,
        setFavorito,
        isMobile1,
        init_props,
        setAllCompany,
        allCompany,
        getOnlyQuery1,
        setGetOnlyQuery1,
        setListCategory,
        listCategory,
        listCaracteristicas,
        listDatas,
        listEstados,
        setListDatas,
        setListCaracteristicas,
        setListEstados,
        ultimaConsulta,
        allViewProperties,
        setUltimaConsulta,
        regiaoAtiva,
        regiaoMatriz,
        modoPopup
    } = useAuth();

    const router = useRouter();
    const { pagination } = router.query;
    const { favoritos } = router.query;
    const { utm_source } = router.query;
    const { utm_medium } = router.query;
    const { utm_id } = router.query;
    const { utm_campaign } = router.query;
    const { promocao } = router.query;
    const { min } = router.query;
    const { area_min } = router.query;
    const { area_max } = router.query;
    const { max } = router.query;
    const { banheiros } = router.query;
    const { dormitorios } = router.query;
    const { id_caracteristica } = router.query;
    const { data_entrega } = router.query;
    const { suites } = router.query;
    const { vagas } = router.query;
    const { ordem } = router.query;
    const { codsite } = router.query;
    const { transacao } = router.query;
    const { agenciador } = router.query;
    const agenciadorRaw = Array.isArray(agenciador) ? agenciador[0] : agenciador;
    const agenciadorParsed = agenciadorRaw ? Number(agenciadorRaw) : 0;
    const agenciadorId = Number.isFinite(agenciadorParsed) ? agenciadorParsed : 0;
    const categoria: number = router.query.categoria ? +router.query.categoria : 0;
    const id_estado: number = router.query.id_estado ? +router.query.id_estado : 0;
    // cs2065: `?pais=<slug>` (utils/filtroPais). Só é lido nas licenças com filtro de país.
    const paisQuery: string = typeof router.query[PAIS_QUERY_PARAM] === 'string' ? String(router.query[PAIS_QUERY_PARAM]) : '';
    const initialAsPath = init_props?.asPath || '';
    const currentAsPath = router.asPath || initialAsPath;
    const codsite2 = init_props?.codsite;
    const routeSearchParams = new URLSearchParams(
        String(currentAsPath || '').split('?')[1] || ''
    );
    const getRouteQueryValue = (value: unknown, key: string) => {
        if (Array.isArray(value)) return value[0];
        if (value !== undefined && value !== null && value !== '') return String(value);
        const fromPath = routeSearchParams.get(key);
        return fromPath !== null ? fromPath : undefined;
    };
    const parsePositiveQueryNumber = (value: unknown) => {
        const rawValue = Array.isArray(value) ? value[0] : value;
        const parsed = Number(rawValue);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
    };
    // BUSCA POR IA (INC-0018 F4): o que SÓ a URL da busca por IA traz — ia=1, quartos/suítes/
    // banheiros/vagas como MÍNIMO (*_min) e o "perto" (utils/buscaIa). Tudo zerado = a listagem
    // de sempre: nada abaixo que dependa disto muda a busca manual, o SEO ou a URL.
    const lerQueryDaUrl = (chave: string) => getRouteQueryValue(router.query?.[chave], chave);
    const buscaIaDaUrl = lerParametrosBuscaIa(lerQueryDaUrl);
    const normalizePath = (path: string) => removerAcentos(path || '').toLowerCase();
    const stripIgnoredQuery = (path: string, ignoreKeys: string[] = []) => {
        const [base, query = ''] = String(path || '').split('?');
        if (!query) return base;
        const params = new URLSearchParams(query);
        ignoreKeys.forEach((key) => params.delete(key));
        const rest = params.toString();
        return rest ? `${base}?${rest}` : base;
    };
    const normalizeForCompare = (path: string) =>
        normalizePath(stripIgnoredQuery(path, ['debugImoveis', 'filtros']));
    const getSearchSignature = (path: string) => normalizeForCompare(path);
    // Assinatura do MAPA: ignora paginação (o mapa sempre usa page:1 + mapa:100, então paginar
    // NÃO muda os marcadores). Mantém `ordem` para preservar o comportamento atual (ordenar
    // atualiza o top-100 do mapa). Assim a paginação não re-busca o mapa (era desperdício).
    const getMapSignature = (path: string) =>
        normalizePath(stripIgnoredQuery(path, ['debugImoveis', 'filtros', 'pagination']));
    const getSearchCacheKey = (path: string) => `ultima_consulta:${getSearchSignature(path)}`;
    const getCachedSearch = (path: string) => getWithTTL<any>(getSearchCacheKey(path));
    // Cache de busca no browser: 60s (era 1h). Casa com a meta de ≤1min — após editar um
    // imóvel no CRM, a busca não pode mostrar resultado velho por horas. O custo de re-buscar
    // é baixo pq o SITE-GRAPHQL serve do cache Redis (HIT ~0,03s).
    const LIST_CACHE_TTL = 60 * 1000; // 60 segundos
    const SEARCH_CACHE_EXPIRES_AT_FIELD = '__imoveisSearchCacheExpiresAt';
    const withSearchCacheTTL = (value: any) => {
        if (!value || typeof value !== 'object') return value;

        return {
            ...value,
            [SEARCH_CACHE_EXPIRES_AT_FIELD]: Date.now() + LIST_CACHE_TTL,
        };
    };
    const isFreshSearchCacheValue = (value: any) => {
        if (!value?.imoveis?.length) return false;

        const expiresAt = Number(value?.[SEARCH_CACHE_EXPIRES_AT_FIELD] || 0);
        return Number.isFinite(expiresAt) && expiresAt > Date.now();
    };
    const getFreshContextSearch = (path: string) => {
        if (getSearchSignature(ultimaConsulta || '') !== getSearchSignature(path || '')) {
            return null;
        }

        return isFreshSearchCacheValue(getOnlyQuery1) ? getOnlyQuery1 : null;
    };
    const normalizeSegmentForLookup = (value: unknown, keepPlusDelimiter = false) => {
        const rawValue = Array.isArray(value) ? value[0] : value;
        const source = String(rawValue ?? '');
        let decoded = source;
        try {
            decoded = decodeURIComponent(source);
        } catch {
            decoded = source;
        }

        let normalized = removerAcentos(decoded).toLowerCase();
        if (!keepPlusDelimiter) {
            normalized = normalized.replaceAll('+', ' ');
        }

        return normalized
            .replaceAll('%20', ' ')
            .replaceAll('---', '-002D-')
            .replaceAll('-', ' ')
            .replaceAll('002D', '-')
            .replaceAll('002d', '-')
            .replaceAll('\n', '-')
            .trim();
    };
    const normalizeLabelForLookup = (value: unknown) =>
        removerAcentos(String(value ?? ''))
            .toLowerCase()
            .replaceAll('\n', '-')
            .trim();
    // Os segmentos CRUS do slug (um por filtro escolhido; '+' separa a seleção múltipla).
    // Servem para o casamento por SLUG — o que sobrevive a nome com "/", que o de-slug de
    // `normalizeSegmentForLookup` não consegue reconstruir (vira espaço e nunca mais volta).
    const segmentosCrusDaUrl = (value: unknown) => {
        const rawValue = Array.isArray(value) ? value.join('+') : value;
        return String(rawValue ?? '')
            .split('+')
            .map((seg) => seg.trim())
            .filter((seg) => seg && seg !== '-');
    };
    // Segmento de filtro para MONTAR a URL da busca. Nome SEM "/" mantém exatamente a URL de
    // hoje (não se mexe em link já publicado/indexado); nome COM "/" passa pelo slug canônico,
    // porque a barra crua estourava um segmento a mais na rota ("/imoveis/venda/-/-/-/escritorio/sala"
    // caía em [type]=escritorio + [code]=sala) e o filtro ia embora junto.
    const segmentoParaUrl = (label: unknown) => {
        const bruto = String(label ?? '');
        if (!bruto) return '';
        if (!bruto.includes('/')) {
            return hifenUrl(bruto, allDataHome?.site?.id).replaceAll(' ', '-').replaceAll('\n', '-');
        }

        const slug = slugSegmentoFiltro(bruto, allDataHome?.site?.id);
        return slug === '-' ? '' : slug;
    };
    const currentSearchSignature = getSearchSignature(currentAsPath || '');
    const initialCached = getFreshContextSearch(currentAsPath || '');

    const renderOnlyTextFilters1 = () => {
        const resposta = currentAsPath.split("/")
        if(categoryActual?.value){
            return categoryActual?.label
        }
        if(dataEntregaActual?.length > 0){
            return `Imóveis com entrega em ${dataEntregaActual?.map((tip: any) => {return tip?.value}).join(",")}`
        }
        if(promocao){
            return 'Promoções'
        }
        if(resposta[7]){
            return 'por código'
        }
        if(resposta[2] == "venda"){
            return 'à venda'
        }
        if(resposta[2] == "aluguel"){
            return 'para alugar'
        }
        if(resposta[2] == "temporada"){
            return 'para Temporada'
        }
        return 'à venda'
    };

    const renderOrdem = () => {
        const options=[
            {
                label: 'Mais Recentes',
                value: 'desc-inclusao',
            },
            {
                label: 'Mais Antigos',
                value: 'asc-inclusao',
            },
            {
                label: 'Maior Valor',
                value: 'desc-valor',
            },
            {
                label: 'Menor Valor',
                value: 'asc-valor',
            },
            {
                label: 'Mais Visitados',
                value: 'desc-visualizacao',
            },
            {
                label: 'Menos Visitados',
                value: 'asc-visualizacao',
            },
            {
                label: 'Exclusivos',
                value: 'asc-exclusivos',
            },
        ]

        const option = options.find(option => option.value === allDataHome?.site?.ordenar_lista);

        return {
            label: option?.label || "",
            value: allDataHome?.site?.ordenar_lista || "",
        }
    }

    const [newPath, setNewPath] = useState(currentAsPath);
    const getArraysPaths = newPath.split('?')[0].split('/');
    const [initialFlow, setInitialFlow] = useState<any>(['home','imóveis',...getArraysPaths.slice(2, getArraysPaths.length).filter((v: any) => !['asc', 'desc'].includes(v)),]);
    const valores: any = {precos_venda: [allDataHome?.precos_venda[0] || [{min:0,max:1000000}]], precos_locacao: [allDataHome?.precos_locacao[0] || [{min:0,max:100000}]]};
    const [allPropertiesMapa, setAllPropertiesMapa] = useState<any>([]);
    const [allProperties, setAllProperties] = useState<any>(initialCached?.imoveis || []);
    const [autorizaBusca, setAutorizaBusca] = useState<any>(false);

    // Atelier (topo 12): as peças da listagem pintam com a paleta da home (papel/tinta/acento).
    const site = siteComPaletaAtelier(allDataHome?.site);
    const atelier = paginaInternaAtelier(site);
    // modelos novos (topo 10–14 / busca 13–17): quartos/suítes/banheiros/vagas com vários números (utils/qtdMultiSelecao)
    const qtdMulti = qtdMultiNoSite(site);
    // modelos novos + cs834 (Daniel 21/10): várias CIDADES (o select multi, antes só no modo multi-filiais) e os
    // bairros de todas elas — é o que a busca da home deles manda (utils/buscaMultiSelecao)
    const localMulti = localMultiNoSite(site);
    // cs2422 (toc2imoveis): o preço que o visitante digita na busca da home vale de verdade.
    // Sem este gate, valor fora dos limites do tenant é trocado, em silêncio, pela faixa INTEIRA
    // (`defaultRange`, abaixo) — quem digitava 300.000 num site só de locação recebia TODOS os
    // imóveis, que foi a reclamação de 29/08. Com ele, a busca devolve o vazio honesto (e as
    // sugestões do empty state). Os outros ~299 sites seguem byte a byte como estão.
    // cs2617: mesma regra para os campos "Valor mínimo"/"Valor máximo" livres da busca da home.
    const respeitaPrecoDigitado = [2422, 2617].includes(Number(allDataHome?.site?.id));
    const [typeActual, setTypeActual] = useState<Array<any>>([]);

    const [orderActual, setOrderActual] = useState<any>(ordem === ORDEM_DISTANCIA
        // busca por IA com "perto": "Mais próximos de {lugar}" — sem o ponto, a ordem padrão
        ? (buscaIaDaUrl.perto ? { label: rotuloOrdemDistancia(buscaIaDaUrl.pertoRotulo), value: ORDEM_DISTANCIA } : renderOrdem())
        : ordem != undefined && ordem != site?.ordenar_lista && !(ordem === 'desc-inclusao' && ordemSemMaisRecentes(site)) ?
        {
            label: String(ordem).replace("asc-","Menos ").replace("desc-","Mais ").replace("Inclusao","Recentes").replace("inclusao","Recentes").replace("Menos Exclusivos","Exclusivos"),
            value: String(ordem)
        }
            :
        renderOrdem()
    );
    // BUSCA POR IA: estado (nasce da URL; a URL vinda de fora o redefine em GetInitialFilters;
    // "Ver todos" zera). O ref é o que GetInitial lê — ele roda por closures antigas do debounce.
    const [estadoBuscaIa, setEstadoBuscaIa] = useState<ParametrosBuscaIa>(buscaIaDaUrl);
    const estadoBuscaIaRef = useRef<ParametrosBuscaIa>(estadoBuscaIa);
    estadoBuscaIaRef.current = estadoBuscaIa;
    // faixa do aviso (gravada pelo hero no sessionStorage) — só lida no navegador
    const [dadosFaixaIa, setDadosFaixaIa] = useState<DadosFaixaBuscaIa | null>(null);
    const bannerListagem = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "listagem");
    const urlBannerListagem = bannerListagem ? bannerListagem.length > 0 ? bannerListagem[0] : null : null;

    const initialValue = {
        suites_min: suites != undefined ? Number(suites) : 0,
        garagems_min: vagas != undefined ? Number(vagas) : 0,
        dormitorios_min: dormitorios != undefined ? Number(dormitorios) : 0,
        banheiros_min: banheiros != undefined ? Number(banheiros) : 0,
        // modelos novos (utils/qtdMultiSelecao): `dormitorios=2,3` = vários números marcados
        ...(qtdMulti ? qtdMultiDaUrl({ suites, vagas, dormitorios, banheiros }) : {})
    };
    const caracteristica = id_caracteristica != undefined ? id_caracteristica : "";
    const datas_entrega = data_entrega != undefined ? data_entrega : "";

    const [activeDrawer, setActiveDrawer] = useState<any>(null);
    const [districtActual, setDistrictActual] = useState<Array<any>>([]);
    const [openFavoritos, setOpenFavoritos] = useState<boolean>(favoritos ? true : false)
    // FAVORITOS (#1117): os ids que chegam pelo link compartilhado. Tolera o que o link traz
    // de sobra — vírgula no fim, espaço, id repetido —, senão o Number() vira NaN e o contador
    // mente ("6 Imóveis Favoritos" para 5 ids).
    const favoritosIds = useMemo<Array<number>>(() => {
        const bruto = Array.isArray(favorito) ? favorito : [];
        const limpos = bruto
            .map((id: any) => Number(id))
            .filter((id: number) => Number.isFinite(id) && id > 0);
        return Array.from(new Set(limpos));
    }, [favorito]);
    // Com a lista de favoritos aberta, o recorte é a seleção do visitante — o filtro de
    // transação sai de cena. O link de compartilhar nasce sempre com a transação priorizada
    // do tenant (/imoveis/venda/...), e isso escondia de quem recebe o link os favoritos que
    // são só de locação/temporada (o corretor mandava 5, o cliente via 3). #1117
    const soFavoritos = openFavoritos && favoritosIds.length > 0;
    // O mesmo vale para a FAIXA DE PREÇO: sem ?min=/?max= na URL ela não é escolha de
    // ninguém, é o range padrão do tenant (no cs2587, R$ 65 mil–80 mi de VENDA) — e derrubava
    // os favoritos de locação, que não têm preço de venda, mesmo já sem o filtro de transação.
    // Quando o visitante mexe no slider (aí sim os valores viajam na URL), o preço continua
    // filtrando normalmente dentro dos favoritos. #1117
    const precoEscolhidoNaUrl = Boolean(getRouteQueryValue(min, 'min') || getRouteQueryValue(max, 'max'));
    const semPrecoNosFavoritos = soFavoritos && !precoEscolhidoNaUrl;
    const [naoEncontrou, setNaoEncontrou] = useState<boolean>(false)
    // Sugestões do empty-state (imóveis do 1º carrossel COM imóveis) — vêm do SSR (tenant-level, cacheado).
    const emptyStateSuggestions: any[] = Array.isArray(init_props?.emptyStateSuggestions) ? init_props.emptyStateSuggestions : []
    const [companyActual, setCompanyActual] = useState<any>(null);
    const [cityActual, setCityActual] = useState<any>(null);
    const [filtersInitialized, setFiltersInitialized] = useState(false);
    const [first, setFirst] = useState(false);
    const [categoryActual, setCategoryActual] = useState<any>(null);
    const [estadoActual, setEstadoActual] = useState<any>(null);
    const [paisActual, setPaisActual] = useState<any>(null);
    const [caractActual, setCaractActual] = useState<Array<{label: string, value: number}>>([]);
    const [dataEntregaActual, setDataEntregaActual] = useState<Array<{label: string, value: number}>>([]);
    const [codeActual, setCodeActual] = useState('');
    const [type, setType] = useState(currentAsPath.split("/")[2] == "temporada" ? 'temporada' : currentAsPath.split("/")[2] == "aluguel" ? 'rent' : 'sale');
    const [idAgenciador, setAgenciador] = useState<number>(agenciadorId);
    const [typeValidation, setTypeValidation] = useState(renderOnlyTextFilters1());
    // Modelo #8 "Horizonte" (topo 11): a listagem fala a língua da home — mesmas cores/CSS vars do
    // CardHorizonte (varsSecao), com fundo = cor5 (o fundo real da listagem). As regras de estilo
    // ficam nos módulos CSS atrás de [data-modelo='horizonte'] na raiz; demais sites: zero diff.
    const horizonte = ehModeloHorizonte(site);
    // Modelos #7 "Aurora" (topo 10) e #10 "Panorama" (topo 13): mesmo esquema — atributo data-modelo na
    // raiz + CSS vars do modelo; as regras ficam nos módulos CSS atrás de [data-modelo='aurora'|'panorama'].
    const aurora = ehModeloAurora(site);
    const panorama = ehModeloPanorama(site);
    // Modelo #11 "Larissa" (topo 14): idem — data-modelo='larissa' + vars --lr-* (varsLarissaInterna) na raiz.
    const larissa = ehModeloLarissa(site);
    // Modelo #12 "Internacional" (topo 16): .lista_in + .interna (régua --in-lateral) + data-modelo='internacional' + vars
    // --in-* da página CLARA (varsInternacionalPagina); títulos na tinta do modelo. Fora do topo 16: zero diff.
    const internacional = ehModeloInternacional(site);
    const corTextoInternacional = internacional ? paletaInternacional(site).tinta : '';
    // Modelo #13 "Norte" (topo 17): idem — .lista_nt + .interna (régua --nt-lado) + data-modelo='norte' + vars --nt-* da
    // página BRANCA (varsNortePagina); títulos na tinta do modelo. Fora do topo 17: zero diff.
    const norte = ehModeloNorte(site);
    const corTextoNorte = norte ? paletaNorte(site).tinta : '';
    // Modelo #14 "Campo" (topo 18): idem — .lista_cp + .interna (régua --cp-lado) + data-modelo='campo' + vars --cp-* da
    // página de PAPEL (varsCampoPagina); títulos na tinta do modelo. Fora do topo 18: zero diff.
    const campo = ehModeloCampo(site);
    const corTextoCampo = campo ? paletaCampo(site).tinta : '';
    // Larissa: o texto legível da página (= --lr-texto da raiz) também nos títulos/descrição com cor inline,
    // e o TÍTULO da listagem em DOIS TONS na serifa (forte + .qtdSuave), como os títulos de seção da home.
    // Fora do topo 14 devolve exatamente os filhos de antes (a string, ou texto + sufixo) — zero diff.
    const corTextoLarissa = larissa ? String(((varsLarissaInterna(site) || {}) as unknown as Record<string, string>)['--lr-texto'] || '') : '';
    const tituloLarissa = (texto: string, sufixo = '') => {
        if (!larissa) return sufixo ? <>{texto}{sufixo}</> : texto;
        const { forte, suave } = tituloEmDoisTons(`${texto}${sufixo}`);
        return suave ? <>{forte} <span className={styles.qtdSuave}>{suave}</span></> : forte;
    };
    // Modelo #12 "Metrópole" (topo 15): idem — data-modelo='metropole' + vars --mt-* (varsMetropoleInterna) na raiz;
    // título leve (300) de um tom só, na cor do texto legível sobre a cor5 (--mt-texto-pagina).
    const metropole = ehModeloMetropole(site);
    const corTextoMetropole = metropole ? String(((varsMetropoleInterna(site) || {}) as unknown as Record<string, string>)['--mt-texto-pagina'] || '') : '';
    const corTextoHorizonte = horizonte
        ? ensureReadableTextColor(isColorLight(site?.cor5 || '#f5f4f1') ? site?.cor11 : site?.cor13, site?.cor5 || '#f5f4f1') || '#141821'
        : '';
    const estiloRaiz: CSSProperties = horizonte
        ? ({
              background: site?.cor5,
              color: corTextoHorizonte,
              '--hz-acento': ensureReadableTextColor(site?.cor2, site?.cor5 || '#f5f4f1', 3.0, corTextoHorizonte, corTextoHorizonte) || corTextoHorizonte,
              '--hz-sutil': hexParaRgba(corTextoHorizonte, 0.14),
              '--hz-sutil-forte': hexParaRgba(corTextoHorizonte, 0.28),
              // botão SÓLIDO do modelo (fundo = cor do texto, texto = fundo): o CSS precisa das duas.
              '--hz-texto': corTextoHorizonte,
              '--hz-fundo': site?.cor5 || '#f5f4f1',
          } as CSSProperties)
        : { background: site?.cor5 };
    // Aurora/Panorama: cores da listagem no visual da home (texto/acento legíveis sobre cor5, painel
    // branco, botão sólido do modelo) — as mesmas que o ListPiecesProperties usa, como CSS vars --lst-*.
    const coresAP = coresListagemAP(site);
    const cor_detalhes = horizonte ? corTextoHorizonte : coresAP ? coresAP.texto : larissa ? corTextoLarissa : metropole ? corTextoMetropole : internacional ? corTextoInternacional : norte ? corTextoNorte : campo ? corTextoCampo : isColorLight(site?.cor5) ? site?.cor11 : site?.cor13;
    const isNovember = new Date().getMonth() === 10;

    const normalizePriceBounds = (bounds: any) => {
        const minValue = Number(bounds?.min);
        const maxValue = Number(bounds?.max);
        const normalizedMin = Number.isFinite(minValue) && minValue >= 0 ? minValue : 0;
        const normalizedMax = Number.isFinite(maxValue) && maxValue >= normalizedMin ? maxValue : normalizedMin;

        return {
            min: normalizedMin,
            max: normalizedMax,
        };
    };
    const getPriceBoundsForType = (currentType?: string | null) => {
        const normalizedType = String(currentType || '').toLowerCase();

        if (normalizedType === 'rent' || normalizedType === 'aluguel') {
            return normalizePriceBounds(valores?.precos_locacao?.[0]);
        }
        if (normalizedType === 'sale' || normalizedType === 'venda') {
            return normalizePriceBounds(valores?.precos_venda?.[0]);
        }
        if (normalizedType === 'temporada') {
            if (valores?.precos_locacao?.[0]?.max) {
                return normalizePriceBounds({ min: 0, max: valores?.precos_locacao?.[0]?.max });
            }

            return normalizePriceBounds({ min: 0, max: valores?.precos_venda?.[0]?.max });
        }

        const fallbackBounds = valores?.precos_venda?.[0]?.max > 0
            ? valores?.precos_venda?.[0]
            : valores?.precos_locacao?.[0];

        return normalizePriceBounds(fallbackBounds);
    };
    const resolvePriceRangeFromQuery = (bounds: any, rawMin: unknown, rawMax: unknown): [number, number] => {
        const safeBounds = normalizePriceBounds(bounds);
        const defaultRange: [number, number] = [safeBounds.min, safeBounds.max];
        const queryMin = parsePositiveQueryNumber(rawMin);
        const queryMax = parsePositiveQueryNumber(rawMax);

        if (!queryMin && !queryMax) {
            return defaultRange;
        }

        const nextMin = queryMin || safeBounds.min;
        const nextMax = queryMax || safeBounds.max;
        const isWithinBounds =
            nextMin >= safeBounds.min &&
            nextMin <= safeBounds.max &&
            nextMax >= safeBounds.min &&
            nextMax <= safeBounds.max;

        if (!isWithinBounds || nextMin > nextMax) {
            // Faixa incoerente (mínimo acima do máximo) continua caindo no default nos dois casos.
            if (respeitaPrecoDigitado && nextMin <= nextMax) {
                return [nextMin, nextMax];
            }
            return defaultRange;
        }

        return [nextMin, nextMax];
    };
    // O Slider do filtro lateral desenha entre estes limites; com o preço escolhido fora deles a
    // bolinha some (o MUI prende no piso/teto). Os limites do DESENHO crescem para caber a escolha —
    // o que vai para a busca continua sendo `price`.
    const boundsComPrecoEscolhido = (bounds: any, faixa?: Array<number>) => {
        const safeBounds = normalizePriceBounds(bounds);
        if (!respeitaPrecoDigitado || !Array.isArray(faixa)) return safeBounds;
        const escolhidoMin = Number(faixa[0]);
        const escolhidoMax = Number(faixa[1]);
        return {
            min: Number.isFinite(escolhidoMin) ? Math.min(safeBounds.min, escolhidoMin) : safeBounds.min,
            max: Number.isFinite(escolhidoMax) ? Math.max(safeBounds.max, escolhidoMax) : safeBounds.max,
        };
    };
    const getFiltersPricess = getPriceBoundsForType(type);
    const minQueryValue = getRouteQueryValue(min, 'min');
    const maxQueryValue = getRouteQueryValue(max, 'max');
    const initialPriceRange = resolvePriceRangeFromQuery(getFiltersPricess, minQueryValue, maxQueryValue);
    const boundsIniciaisSlider = boundsComPrecoEscolhido(getFiltersPricess, initialPriceRange);
    const [filterPrice, setFilterPrice] = useState<any>(!boundsIniciaisSlider?.min && !boundsIniciaisSlider?.max ? { min: 0, max: 0 } : boundsIniciaisSlider);
    const [price, setPrice] = useState<Array<number>>(initialPriceRange);
    const [area, setArea] = useState<Array<any>>(area_min || area_max ? [area_min ? area_min : 0,area_max ? area_max : 0] : [0,0]);
    const [page, setPage] = useState<number>(pagination ? Number(pagination) : 1);
    const [qtd, setQtd] = useState(initialCached?.count || 0);
    const [listDistrict, setListDistrict] = useState<any>([]);
    const listType = allDataHome?.tipos ? formatSelects(allDataHome?.tipos) : [];
    // O select mostra a lista podada (utils/tiposBuscaOcultos.ts); `listType` fica
    // INTEIRO porque é ele que resolve o tipo que vem na URL em GetInitialFilters —
    // podá-lo faria /imoveis/venda/<cidade>/-/-/<tipo escondido> deixar de filtrar.
    // e um tipo por NOME (utils/tiposHomonimos: o xará do tipo global com o do tenant aparecia duas vezes)
    const listTypeSelect = umTipoPorNome(filtrarTiposDoSelect(listType, codsite2));
    const [companyInputActual, setCompanyInputActual] = useState('');
    const [allUrl, setAllUrl] = useState('');
    const [loading, setLoading] = useState<any>(!initialCached?.imoveis?.length);
    const [listCacheExpiresAt, setListCacheExpiresAt] = useState<number>(
        Number(initialCached?.[SEARCH_CACHE_EXPIRES_AT_FIELD] || 0)
    );
    // MULTI-REGIÃO: GetInitial pode rodar por closures antigas (debounce), então a
    // região ativa é lida via ref (sempre o valor mais recente no momento do fetch).
    const regiaoAtivaRef = useRef<any>(null);
    regiaoAtivaRef.current = regiaoAtiva;
    // MULTI-FILIAIS: mesmo motivo (closures antigas) para a matriz e o modo.
    const regiaoMatrizRef = useRef<any>(null);
    regiaoMatrizRef.current = regiaoMatriz;
    const modoPopupRef = useRef<boolean>(false);
    modoPopupRef.current = Boolean(modoPopup);
    // MULTI-FILIAIS: cidades marcadas no select multi (só no modo popup). Nasce
    // do `?cidades=` da URL e passa a ser mantida pelo filtro da listagem.
    const [cidadesMultiIds, setCidadesMultiIds] = useState<number[]>([]);
    const cidadesMultiRef = useRef<number[]>([]);
    cidadesMultiRef.current = cidadesMultiIds;
    const cidadesSeedRef = useRef(false);
    const [pendingScroll, setPendingScroll] = useState<number | null>(null);
    const scrollKeyRef = useRef<string>('');
    const scrollRestoreAttemptsRef = useRef(0);
    const scrollRestoreRafRef = useRef<number | null>(null);
    const initialUrlRef = useRef<string>('');
    const initialComparableRef = useRef<string>('');
    const userActionRef = useRef(false);
    const lastCardRef = useRef<any>(null);
    const [disableEntryMotion, setDisableEntryMotion] = useState(false);
    const [filters, setFilters] = useState<any>(initialValue);
    const [activeLargeFilter, setActiveLargeFilter] = useState(false);
    // MULTI-FILIAIS: o select de cidade da listagem fica restrito às cidades da
    // filial ativa (fail-open: recorte vazio → lista inteira).
    const allCitiesTenant = allDataHome?.cidades ? formatSelects(allDataHome?.cidades,allDataHome?.site?.cidade_priorizada ) : [];
    const allCities = filtraCidadesRegiao<any>(allCitiesTenant, regiaoAtiva);
    const [listCity, setListCity] = useState<any>(allCities);
    // Ressincroniza o select quando o visitante TROCA de filial (o estado só
    // nasce na 1ª montagem). Não dispara na montagem nem em tenant mono-região.
    // ids de `?cidades=` — semeiam tanto o estado da página quanto os chips do
    // select multi do filtro (identidade estável: o efeito de seed não relaça).
    const cidadesSeedIds = useMemo(
        () => parseCidadesQuery(router.query?.[CIDADES_QUERY_PARAM]),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [router.isReady, String(router.query?.[CIDADES_QUERY_PARAM] || '')]
    );
    useEffect(() => {
        if (!router.isReady || cidadesSeedRef.current) return;
        cidadesSeedRef.current = true;
        if (cidadesSeedIds.length) setCidadesMultiIds(cidadesSeedIds);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.isReady, cidadesSeedIds]);
    // cs834 (utils/buscaMultiSelecao): CONDOMÍNIOS e CATEGORIAS com 2+ marcados — mesma
    // mecânica das cidades: nascem do `?condominios=`/`?categorias=` da URL, depois o filtro da
    // listagem mantém; ref porque o GetInitial roda por closures antigas do debounce.
    const buscaMulti = buscaMultiSelecao(allDataHome?.site?.id);
    const condominiosSeedIds = useMemo(
        () => (buscaMulti ? parseIdsQuery(router.query?.[CONDOMINIOS_QUERY_PARAM]) : []),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [buscaMulti, router.isReady, String(router.query?.[CONDOMINIOS_QUERY_PARAM] || '')]
    );
    const categoriasSeedIds = useMemo(
        () => (buscaMulti ? parseIdsQuery(router.query?.[CATEGORIAS_QUERY_PARAM]) : []),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [buscaMulti, router.isReady, String(router.query?.[CATEGORIAS_QUERY_PARAM] || '')]
    );
    const [condominiosMultiIds, setCondominiosMultiIds] = useState<number[]>([]);
    const [categoriasMultiIds, setCategoriasMultiIds] = useState<number[]>([]);
    const condominiosMultiRef = useRef<number[]>([]);
    condominiosMultiRef.current = condominiosMultiIds;
    const categoriasMultiRef = useRef<number[]>([]);
    categoriasMultiRef.current = categoriasMultiIds;
    const filtrosMultiSeedRef = useRef(false);
    useEffect(() => {
        if (!router.isReady || filtrosMultiSeedRef.current) return;
        filtrosMultiSeedRef.current = true;
        if (condominiosSeedIds.length >= 2) setCondominiosMultiIds(condominiosSeedIds);
        if (categoriasSeedIds.length >= 2) setCategoriasMultiIds(categoriasSeedIds);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.isReady, condominiosSeedIds, categoriasSeedIds]);
    // "Ver todos os imóveis" (zeraFiltros) avisa o filtro da listagem para desmarcar as listas.
    const [zeraMultiToken, setZeraMultiToken] = useState(0);

    const regiaoSlugCidadesRef = useRef<string | null>(null);
    useEffect(() => {
        const slug = regiaoAtiva?.slug || '';
        if (regiaoSlugCidadesRef.current === null) {
            regiaoSlugCidadesRef.current = slug;
            return;
        }
        if (regiaoSlugCidadesRef.current === slug) return;
        regiaoSlugCidadesRef.current = slug;
        setListCity(allCities);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [regiaoAtiva?.slug]);
    const codsite1 = init_props?.codsite;
    const origin = init_props?.origemInit;
    const storageHost =
        init_props?.prodOrigin ||
        init_props?.origemInit ||
        site?.site ||
        (typeof window !== 'undefined' ? window.location.host : '');
    const storageCodsite = init_props?.codsite || site?.id || 0;
    const listCategoryStorageKey = getImoveisListCategoryStorageKey(storageHost, storageCodsite);
    const listStatesStorageKey = getImoveisListStatesStorageKey(storageHost, storageCodsite);
    const listDatasStorageKey = getImoveisListDatasStorageKey(storageHost, storageCodsite);
    const listCaracteristicasStorageKey = getImoveisListCaracteristicasStorageKey(storageHost, storageCodsite);
    const condosStorageKey = getHomeScopedStorageKey(condominiosStorageName(allDataHome?.site?.id || storageCodsite), storageHost, storageCodsite);
    const hasStateFilter = site?.id == 2177 || site?.id == 2297 || site?.id == 1942 || site?.id == 2065;
    // cs2065: País e Estado em dois filtros (utils/filtroPais). Os países saem da lista de estados.
    const filtroPais = temFiltroPais(site?.id);
    const listStatesPaisStorageKey = getEstadosComPaisStorageKey(storageHost, storageCodsite);
    const listPaises = useMemo(() => (filtroPais ? listarPaises(listEstados) : []), [filtroPais, listEstados]);
    const searchEventRef = useRef<{ key: string; at: number } | null>(null);
    const latestListRequestRef = useRef<{ id: number; signature: string }>({ id: 0, signature: '' });
    const latestMapSignatureRef = useRef<string>('');
    const latestCompanyRequestRef = useRef(0);
    // Assinatura da navegação que ESTE componente acabou de causar (router.push shallow pós-busca).
    // O efeito que re-roda GetInitialFilters no currentSearchSignature deve IGNORAR esse "eco"
    // (senão re-parseia a URL + refaz seletores + re-arma setAutorizaBusca = busca duplicada).
    const selfNavSignatureRef = useRef<string>('');
    // Cancela a requisição de lista/mapa anterior quando uma nova busca é iniciada (supera o socket).
    const listAbortRef = useRef<AbortController | null>(null);
    const seoTransaction = type === 'rent' ? 'aluguel' : type === 'temporada' ? 'temporada' : 'venda';
    const imoveisSeo = buildImoveisSeo({
        asPath: currentAsPath,
        site,
        allDataHome,
        query: router.query,
        rotulos: init_props?.rotulosHifen,
        overrides: {
            transaction: seoTransaction,
            city: cityActual?.label,
            districts: districtActual?.map((item: any) => item?.label),
            types: typeActual?.map((item: any) => item?.label),
            company: companyActual?.label,
            category: categoryActual?.label,
            code: codeActual,
            dormitorios: qtdParaUrl(filters, 'dormitorios_min'),
            suites: qtdParaUrl(filters, 'suites_min'),
            banheiros: qtdParaUrl(filters, 'banheiros_min'),
            vagas: qtdParaUrl(filters, 'garagems_min'),
            promocao: promocao == '1',
            favoritos: openFavoritos,
        },
    });
    // Conteúdo de SEO por cidade configurado no CRM (tbl_seo_cidade), trazido no SSR.
    // Decisão Daniel (22/06): o texto rico + FAQ ficam SÓ no RODAPÉ da página (é conteúdo p/ o
    // Google; no topo poluía visualmente). O topo mantém apenas o intro CURTO programático.
    const seoCidade = init_props?.seoCidade;
    const seoCidadeFaq = Array.isArray(seoCidade?.faq)
        ? seoCidade.faq.filter((q: any) => q?.pergunta && q?.resposta)
        : [];
    // Topo: só o intro curto do buildImoveisSeo (o texto do CRM NÃO entra aqui — vai no rodapé).
    const renderSeoIntro = () =>
        imoveisSeo?.intro ? (
            <p className={styles.seoDescription} style={{ color: cor_detalhes }}>
                {imoveisSeo.intro}
            </p>
        ) : null;
    // Rodapé SEO da cidade (SSR): título (H2) + texto rico do CRM + FAQ visível (pareia o
    // JSON-LD FAQPage do ImoveisSchema). Renderizado no fim da página, só quando o CRM tem conteúdo.
    const renderSeoCidadeRodape = () =>
        seoCidade?.texto || seoCidade?.fotoUrl || seoCidadeFaq.length ? (
            <section className={styles.seoCityFooter}>
                {seoCidade?.titulo ? (
                    <h2 className={styles.seoCityTitle} style={{ color: cor_detalhes }}>{seoCidade.titulo}</h2>
                ) : null}
                {seoCidade?.fotoUrl ? (
                    // eslint-disable-next-line @next/next/no-img-element
                    <img
                        className={styles.seoCityFoto}
                        src={seoCidade.fotoUrl}
                        alt={seoCidade?.titulo || 'Imóveis na cidade'}
                        loading="lazy"
                    />
                ) : null}
                {seoCidade?.texto ? (
                    <div
                        className={styles.seoDescription}
                        style={{ color: cor_detalhes }}
                        dangerouslySetInnerHTML={{ __html: seoCidade.texto }}
                    />
                ) : null}
                {seoCidadeFaq.length ? (
                    <div className={styles.seoFaq}>
                        {seoCidadeFaq.map((q: any, i: number) => (
                            <div className={styles.seoFaqItem} key={i}>
                                <h3 style={{ color: cor_detalhes }}>{q.pergunta}</h3>
                                <p style={{ color: cor_detalhes }}>{q.resposta}</p>
                            </div>
                        ))}
                    </div>
                ) : null}
            </section>
        ) : null;

    const setSearchContextCache = (value: any) => {
        const valueWithTTL = withSearchCacheTTL(value);
        setGetOnlyQuery1(valueWithTTL);
        setListCacheExpiresAt(Number(valueWithTTL?.[SEARCH_CACHE_EXPIRES_AT_FIELD] || 0));
    };

    const expireSearchContextCache = () => {
        setGetOnlyQuery1([]);
        setListCacheExpiresAt(0);
        if (typeof window !== 'undefined') {
            localStorage.removeItem(getSearchCacheKey(currentAsPath || ''));
        }
    };

    const readLocalStorageValue = <T,>(key: string, fallback: T): T => {
        if (typeof window === 'undefined') return fallback;
        return readJsonStorageValue<T>(window.localStorage, key, fallback);
    };

    const readLocalArray = (key: string) => {
        const value = readLocalStorageValue<any>(key, []);
        return Array.isArray(value) ? value : [];
    };

    const withReadyDeliveryOption = (value: any) => {
        const options = Array.isArray(value) ? value.filter(Boolean) : [];
        const readyItem = { label: 'ImÃ³vel Pronto', value: 1 };
        const remaining = options.filter(
            (item: any) => !(item?.label === readyItem.label && item?.value === readyItem.value)
        );

        return [readyItem, ...remaining];
    };

    const buildCompanyOptions = (value: any, includeBlankOption = true) => {
        const source = Array.isArray(value?.empreendimentos)
            ? value.empreendimentos
            : Array.isArray(value)
                ? value
                : [];
        const options = source
            .map((item: any) => {
                if (!item) return null;

                if (item?.label !== undefined && item?.value !== undefined) {
                    return {
                        label: String(item.label || '').trim(),
                        value: item.value,
                        id_estado: item?.id_estado ? item.id_estado : 0,
                    };
                }

                if (item?.nome && item?.id) {
                    return {
                        label: String(item.nome).trim(),
                        value: item.id,
                        id_estado: item?.id_estado ? item.id_estado : 0,
                    };
                }

                return null;
            })
            .filter((item: any) => item && item.label && item.value !== null && item.value !== undefined);

        if (!includeBlankOption || options.length === 0) {
            return options;
        }

        return [{ label: '', value: null, id_estado: 0 }, ...options];
    };

    const warnStorageBootstrap = (scope: string, error: unknown) => {
        if (process.env.NODE_ENV !== 'production') {
            console.warn(`[imoveis] falha ao inicializar storage em ${scope}`, error);
        }
    };

    const resetBootstrapLists = () => {
        if (site?.categoria_home) {
            setListCategory([]);
        }
        if (hasStateFilter) {
            setListEstados([]);
        }
        if (site?.mostrar_data_entrega) {
            setListDatas([]);
        }
        if (site?.caracteristicas_home) {
            setListCaracteristicas([]);
        }
    };

    const beginListRequest = (signature: string) => {
        const nextId = latestListRequestRef.current.id + 1;
        latestListRequestRef.current = { id: nextId, signature };
        return nextId;
    };

    const isLatestListRequest = (requestId: number, signature: string) => {
        return (
            latestListRequestRef.current.id === requestId &&
            latestListRequestRef.current.signature === signature
        );
    };

    useEffect(() => {
        if (pagination && Number(pagination) != page) {
            setPage(Number(pagination || 1));
        }
    }, [pagination]);

    const setAutorizaBuscaFromUser = (value: any) => {
        if (value) {
            userActionRef.current = true;
        }
        setAutorizaBusca(value);
    };

    useEffect(() => {
        if (!listCacheExpiresAt || typeof window === 'undefined') return;

        const refreshExpiredSearch = () => {
            // PASSIVO: só expira o cache. NÃO re-dispara a busca nem mostra loading enquanto
            // o usuário está com a página aberta — fazer setLoading(true)+setAutorizaBusca(true)
            // a cada 60s (LIST_CACHE_TTL) parecia "a página recarregando sozinha" no scroll.
            // A próxima interação (filtro/paginação/navegação) re-busca fresco do cache expirado.
            expireSearchContextCache();
        };
        const expiresInMs = listCacheExpiresAt - Date.now();

        if (expiresInMs <= 0) {
            refreshExpiredSearch();
            return;
        }

        const timeoutId = window.setTimeout(refreshExpiredSearch, expiresInMs);
        return () => window.clearTimeout(timeoutId);
    }, [listCacheExpiresAt, currentSearchSignature, router.isReady, filtersInitialized]);

    // methods
    useEffect(() => {
        if (favorito === null) {
            setOpenFavoritos(false)
        }
    }, [favorito]);

    useEffect(() => {
        if (!initialUrlRef.current) {
            const raw = currentAsPath || '';
            initialUrlRef.current = raw;
            initialComparableRef.current = getSearchSignature(raw);
        }
    }, [currentAsPath]);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const raw = sessionStorage.getItem('imoveis:lastCard');
        if (!raw) {
            lastCardRef.current = null;
            setDisableEntryMotion(false);
            return;
        }
        try {
            lastCardRef.current = JSON.parse(raw);
            const currentComparable = getSearchSignature(currentAsPath || '');
            const lastComparable = getSearchSignature(lastCardRef.current?.path || '');
            setDisableEntryMotion(currentComparable === lastComparable);
        } catch {
            lastCardRef.current = null;
            setDisableEntryMotion(false);
        }
    }, [currentAsPath]);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const key = `imoveis:scroll:${normalizePath(currentAsPath || '')}`;
        scrollKeyRef.current = key;

        const saved = sessionStorage.getItem(key);
        if (saved) {
            const parsed = Number(saved);
            if (!Number.isNaN(parsed)) {
                setPendingScroll(parsed);
            }
        }

        const hasScrollRestoration = 'scrollRestoration' in window.history;
        const prevRestoration = hasScrollRestoration
            ? window.history.scrollRestoration
            : 'auto';
        if (hasScrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }

        return () => {
            if (hasScrollRestoration) {
                window.history.scrollRestoration = prevRestoration;
            }
            const y = window.scrollY || 0;
            sessionStorage.setItem(key, String(y));
        };
    }, [currentAsPath]);

    useEffect(() => {
        if ((pendingScroll === null && !lastCardRef.current) || loading) return;

        scrollRestoreAttemptsRef.current = 0;

        const attemptRestore = () => {
            const maxScroll = Math.max(
                0,
                document.documentElement.scrollHeight - window.innerHeight
            );

            const lastCard = lastCardRef.current;
            const cardEl = lastCard?.id
                ? document.getElementById(`imovel-card-${lastCard?.id}`)
                : null;
            const cardTarget = cardEl
                ? Math.max(
                    0,
                    cardEl.getBoundingClientRect().top +
                        window.scrollY -
                        (lastCard?.viewportTop ?? 0)
                )
                : null;

            const scrollTarget = pendingScroll ?? 0;
            const target = cardTarget !== null ? cardTarget : Math.min(Math.max(0, scrollTarget), maxScroll);
            const ready = maxScroll + 8 >= target;

            if ((ready || scrollRestoreAttemptsRef.current >= 40) && target !== null) {
                window.scrollTo({ top: target, behavior: 'auto' });
                if (scrollKeyRef.current) {
                    sessionStorage.removeItem(scrollKeyRef.current);
                }
                if (cardEl) {
                    sessionStorage.removeItem('imoveis:lastCard');
                    lastCardRef.current = null;
                }
                setDisableEntryMotion(false);
                setPendingScroll(null);
                scrollRestoreAttemptsRef.current = 0;
                return;
            }

            if (scrollRestoreAttemptsRef.current >= 40) {
                if (lastCardRef.current) {
                    sessionStorage.removeItem('imoveis:lastCard');
                    lastCardRef.current = null;
                }
                setDisableEntryMotion(false);
                setPendingScroll(null);
                scrollRestoreAttemptsRef.current = 0;
                return;
            }

            scrollRestoreAttemptsRef.current += 1;
            scrollRestoreRafRef.current = requestAnimationFrame(attemptRestore);
        };

        scrollRestoreRafRef.current = requestAnimationFrame(attemptRestore);

        return () => {
            if (scrollRestoreRafRef.current) {
                cancelAnimationFrame(scrollRestoreRafRef.current);
            }
        };
    }, [pendingScroll, loading, allProperties?.length, currentAsPath]);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (allProperties?.length > 0) return;

        const pathNow = getSearchSignature(currentAsPath || '');
        const cached = getCachedSearch(currentAsPath || '');
        if (cached?.imoveis?.length > 0) {
            setAllProperties(cached.imoveis);
            setQtd(cached.count || 0);
            setSearchContextCache(cached);
            if (!ultimaConsulta) {
                setUltimaConsulta(pathNow);
            }
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if(newPath){
            const getArraysPaths = newPath.split('?')[0].split('/');
            setInitialFlow([
                'home',
                'imóveis',
                ...getArraysPaths
                    .slice(2, getArraysPaths.length)
                    .filter((v: any) => !['asc', 'desc'].includes(v)),
            ]);
        }
    }, [newPath]);

    useEffect(() => {
        if (!router.isReady) return;
        // Eco da auto-navegação (router.push shallow que a própria busca fez): não re-rodar
        // GetInitialFilters (que re-armaria setAutorizaBusca -> busca duplicada). Consome 1x.
        if (selfNavSignatureRef.current && currentSearchSignature === selfNavSignatureRef.current) {
            selfNavSignatureRef.current = '';
            return;
        }

        const timeOutId = setTimeout(() => {
            GetInitialFilters();
        }, 500);

        return () => clearTimeout(timeOutId);
    }, [router.isReady, currentSearchSignature]);

    const GetInitialFilters2 = async () => {
        try {
        if(listCategory === 0 && site?.categoria_home){
            const getCondo: any = readLocalArray(listCategoryStorageKey);

            if(getCondo?.length > 0){
                setListCategory(getCondo);
                if(Number.isInteger(categoria) && categoria > 0){
                    const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === categoria);
                    if(objeto){
                        setCategoryActual(objeto)
                    } else {
                        // A lista de categorias guardada no navegador do visitante não tem
                        // validade: quem visitou o site ANTES de a imobiliária criar a categoria
                        // fica com a lista velha para sempre. Como a busca só manda
                        // `id_categoria` quando acha a categoria nesta lista, o filtro da URL era
                        // descartado em silêncio e a listagem vinha inteira (cs2422: 56 imóveis de
                        // aluguel em vez dos 15 de "Residencial"). Aqui a lista é rebuscada no
                        // servidor e regravada; se a categoria realmente não existir mais, nada
                        // muda em relação a antes (o filtro segue ignorado).
                        const infoCategoryFresh = await categorias(origin, codsite1);
                        const formatCategoriasFresh = formatSelects(infoCategoryFresh?.categorias);
                        if(formatCategoriasFresh?.length > 0){
                            const objetoFresh = formatCategoriasFresh.find((item: { label: string; value: number; }) => item.value === categoria);
                            localStorage.setItem(listCategoryStorageKey, JSON.stringify(formatCategoriasFresh));
                            setListCategory(formatCategoriasFresh);
                            if(objetoFresh){
                                setCategoryActual(objetoFresh)
                            }
                        }
                    }
                }
            } else {
                const infoCategory = await categorias(origin, codsite1);
                if(infoCategory){
                    const formatCategorias = formatSelects(infoCategory?.categorias);
                    if(formatCategorias?.length > 0){
                        if(Number.isInteger(categoria) && categoria > 0){
                            const objeto = formatCategorias.find((item: { label: string; value: number; }) => item.value === categoria);
                            if(objeto){
                                setCategoryActual(objeto)
                            }
                        }
                        localStorage.setItem(listCategoryStorageKey, JSON.stringify(formatCategorias));
                        setListCategory(formatCategorias);
                    }
                    else
                        setListCategory([]);
                }
                
            }
        } else {
            if(Number.isInteger(categoria) && categoria > 0 && listCategory && !autorizaBusca){
                const getCondo = listCategory || []
                const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === categoria);
                if(objeto){
                    setCategoryActual(objeto)
                }
            }
        }

        if(filtroPais){
            // cs2065: País e Estado separados (utils/filtroPais). Aqui a URL manda: `?pais=` e
            // `?id_estado=` (estado de outro país que o da URL é descartado).
            const lista = listEstados === 0
                ? await carregarEstadosComPais(listStatesPaisStorageKey, () => get_estados(origin, codsite1))
                : listEstados;
            if(listEstados === 0){
                setListEstados(lista);
            }
            const { pais, estado } = resolverPaisEstado(lista, paisQuery, id_estado);
            setPaisActual(pais);
            setEstadoActual(estado);
            setListCity(
                estado
                    ? allCities.filter((city: { id_estado: any; }) => city?.id_estado === estado.value)
                    : cidadesDoPais(allCities, lista, pais?.value)
            );
        } else if(listEstados === 0 && hasStateFilter){
            const getCondo: any = readLocalArray(listStatesStorageKey);
   
            if(getCondo?.length > 0){
                setListEstados(getCondo);
                if(Number.isInteger(id_estado) && id_estado > 0){
                    const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === id_estado);
                    if(objeto){
                        setEstadoActual(objeto)
                        if(objeto.value > 0){
                            const cidadesFiltradas = allCities.filter(
                                (city: { id_estado: any; }) => city?.id_estado === objeto.value
                            );
                
                            setListCity(cidadesFiltradas)
                        }
                    }
                }
            } else {
                const infoCategory = await get_estados(origin, codsite1);
                if(infoCategory){
                    const formatCategorias = formatSelects(infoCategory?.estados);
                    if(formatCategorias?.length > 0){
                        if(Number.isInteger(id_estado) && id_estado > 0){
                            const objeto = formatCategorias.find((item: { label: string; value: number; }) => item.value === id_estado);
                            if(objeto){
                                setEstadoActual(objeto)

                                if(objeto.value > 0){
                                    const cidadesFiltradas = allCities.filter(
                                        (city: { id_estado: any; }) => city?.id_estado === objeto.value
                                    );
                        
                                    setListCity(cidadesFiltradas)
                                }
                            }
                        }
                        localStorage.setItem(listStatesStorageKey, JSON.stringify(formatCategorias));
                        setListEstados(formatCategorias);
                    } else {
                        setListEstados([]);
                    }
                }
            }
        } else {
            if(Number.isInteger(id_estado) && id_estado > 0 && listEstados){
                const getCondo = listEstados || []
                const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === id_estado);
                if(objeto){
                    setEstadoActual(objeto)
                }
            }
        }

        if(listDatas === 0 && site?.mostrar_data_entrega){
            const getCondo: any = readLocalArray(listDatasStorageKey);

            if(getCondo?.length > 0){
                const normalizedDatas = withReadyDeliveryOption(getCondo);
                setListDatas(normalizedDatas);
                if(datas_entrega){
                    const DatasArray = String(datas_entrega)
                        ?.split(',')                       // Dividir a string por vírgula
                        .map(str => str.trim())             // Remover espaços extras
                        .map(Number)                        // Converter cada item para número
                        .filter(num => !isNaN(num));        // Filtrar valores que não são números
                    const GetOnlyDatas = normalizedDatas?.filter((e: any) => {
                        return DatasArray.includes(e.value);
                    });

                    setDataEntregaActual(GetOnlyDatas ? GetOnlyDatas : []);
                }
            } else {
                const infoDatas = await allDatasEntrega(origin, codsite1);
                const formatDatas = Array.isArray(infoDatas?.datas_entrega)
                    ? withReadyDeliveryOption(formatSelectsTransacao(infoDatas.datas_entrega))
                    : [];
                const newItem = { "label": "Imóvel Pronto", "value": 1 };

                // Adiciona o novo item no início do array
                void newItem;
                if(formatDatas?.length > 0){
                    if(datas_entrega){
                        const DatasArray = String(datas_entrega)
                            ?.split(',')                       // Dividir a string por vírgula
                            .map(str => str.trim())             // Remover espaços extras
                            .map(Number)                        // Converter cada item para número
                            .filter(num => !isNaN(num));        // Filtrar valores que não são números

                        // Passo 2: Filtrar o array 'getCondo' usando os valores do array de características
                        const GetOnlyDatas = formatDatas?.filter((e: any) => {
                            return DatasArray.includes(e.value);
                        });

                        setDataEntregaActual(GetOnlyDatas ? GetOnlyDatas : []);
                    }
                    setListDatas(formatDatas);
                    localStorage.setItem(listDatasStorageKey, JSON.stringify(formatDatas));
                }
                else
                    setListDatas([]);
            }
        } else {
            if(datas_entrega && listDatas){
                const getCondo: any = listDatas || []
                const DatasArray = String(datas_entrega)
                    ?.split(',')                       // Dividir a string por vírgula
                    .map(str => str.trim())             // Remover espaços extras
                    .map(Number)                        // Converter cada item para número
                    .filter(num => !isNaN(num));        // Filtrar valores que não são números
                const GetOnlyDatas = getCondo?.filter((e: any) => {
                    return DatasArray.includes(e.value);
                });

                setDataEntregaActual(GetOnlyDatas ? GetOnlyDatas : []);
            }
        }

        if(listCaracteristicas === 0 && site?.caracteristicas_home){
            const getCondo = getWithTTL<any>(listCaracteristicasStorageKey);

            if(getCondo?.length > 0){
                setListCaracteristicas(getCondo);
                if(caracteristica){
                    const caracteristicasArray = String(caracteristica)
                        ?.split(',')                       // Dividir a string por vírgula
                        .map(str => str.trim())             // Remover espaços extras
                        .map(Number)                        // Converter cada item para número
                        .filter(num => !isNaN(num));        // Filtrar valores que não são números

                    const GetOnlyCar = getCondo?.filter((e: any) => {
                        return caracteristicasArray.includes(e.value);
                    });

                    setCaractActual(GetOnlyCar ? GetOnlyCar : []);
                }
            } else {
                const infoCaracteristicas= await allCaracteristicas(origin, codsite1);
                const formatCarac = formatCaracteristicas(infoCaracteristicas?.caracteristicas);
                if(formatCarac?.length > 0){
                    setListCaracteristicas(formatCarac);

                    if(caracteristica){
                        const caracteristicasArray = String(caracteristica)
                            ?.split(',')                       // Dividir a string por vírgula
                            .map(str => str.trim())             // Remover espaços extras
                            .map(Number)                        // Converter cada item para número
                            .filter(num => !isNaN(num));        // Filtrar valores que não são números

                        // Passo 2: Filtrar o array 'getCondo' usando os valores do array de características
                        const GetOnlyCar = formatCarac?.filter((e: any) => {
                            return caracteristicasArray.includes(e.value);
                        });

                        setCaractActual(GetOnlyCar ? GetOnlyCar : []);
                    }
                    const DAY_MS = 24 * 60 * 60 * 1000; // 86_400_000
                    setWithTTL(listCaracteristicasStorageKey, formatCarac, DAY_MS);
                }
                else
                setListCaracteristicas([]);
            }
        } else {
            if(caracteristica && listCaracteristicas){
                const getCaract: any = listCaracteristicas || []
                const caracteristicasArray = String(caracteristica)
                    ?.split(',')                       // Dividir a string por vírgula
                    .map(str => str.trim())             // Remover espaços extras
                    .map(Number)                        // Converter cada item para número
                    .filter(num => !isNaN(num));        // Filtrar valores que não são números

                const GetOnlyCar = getCaract?.filter((e: any) => {
                    return caracteristicasArray.includes(e.value);
                });

                setCaractActual(GetOnlyCar ? GetOnlyCar : []);
            }
        }
        } catch (error) {
            warnStorageBootstrap('GetInitialFilters2', error);
            resetBootstrapLists();
        } finally {
            setAutorizaBusca(true);
        }
    }

    const GetInitialFilters = async () => {
        if (!router.isReady) return;

        try {
        // BUSCA POR IA: URL que chegou de FORA (hero, link "Também em", voltar do navegador) manda
        // no estado da IA, na ordem "Mais próximos" e na faixa. Sem nada de IA na URL e sem estado
        // de IA, não mexe em nada (listagem manual intocada).
        const iaDaUrl = lerParametrosBuscaIa(lerQueryDaUrl);
        if (buscaIaAtiva(iaDaUrl) || buscaIaAtiva(estadoBuscaIaRef.current)) {
            setEstadoBuscaIa(iaDaUrl);
            setDadosFaixaIa(iaDaUrl.ia ? lerFaixaBuscaIa(currentAsPath) : null);
            if (iaDaUrl.perto && ordem === ORDEM_DISTANCIA) {
                setOrderActual({ label: rotuloOrdemDistancia(iaDaUrl.pertoRotulo), value: ORDEM_DISTANCIA });
            } else if (!iaDaUrl.perto && orderActual?.value === ORDEM_DISTANCIA) {
                setOrderActual(renderOrdem());
            }
        }
        let formatType = listType;
        let formatCities = allCities;

        if (agenciadorId > 0) {
            setAgenciador(agenciadorId);
        }
        const pathNow = getSearchSignature(currentAsPath || '');
        const hasContextCache = !!getFreshContextSearch(pathNow);
        const hasStorageCache =
            !hasContextCache &&
            typeof window !== 'undefined' &&
            !!getCachedSearch(currentAsPath || '')?.imoveis?.length;
        if (!hasContextCache && !hasStorageCache) {
            setLoading(true);
        }
        if(banheiros || dormitorios || vagas || suites) {
            setFilters({'suites_min': Number(suites) || 0, 'garagems_min': Number(vagas) || 0, 'dormitorios_min': Number(dormitorios) || 0, 'banheiros_min': Number(banheiros) || 0, ...(qtdMulti ? qtdMultiDaUrl({ suites, vagas, dormitorios, banheiros }) : {})})
        }

        if(hasStateFilter){
            if(id_estado > 0){
                const cidadesFiltradas = allCities.filter(
                    (city: { id_estado: number; }) => city?.id_estado === id_estado
                );
    
                setListCity(cidadesFiltradas)
            } else {
                if(estadoActual?.value){
                    const cidadesFiltradas = allCities.filter(
                        (city: { id_estado: any; }) => city?.id_estado === estadoActual?.value
                    );
        
                    setListCity(cidadesFiltradas)
                } else {
                    setListCity(allCities);
                }
            }
        }

        let GetOnlyType = null;
        let getCity: any = null;
        let getDistrict = null;
        // let GetOnlyCompany = null;
        const query_type = router.query?.type != '[type]' ? router.query?.type || '-' : '-'
        const query_city = router.query?.city != '[city]' ? router.query?.city || '-' : '-'
        const query_district = router.query?.district != '[district]' ? router.query?.district || '-' : '-'
        const query_company = router.query?.company != '[company]' ? router.query?.company : '-'
        const query_transacao = router.query?.model == 'venda' || router.query?.model == 'aluguel' || router.query?.model == 'temporada' ? router.query?.model : 'venda'
        const getFiltersPrices1 = getPriceBoundsForType(query_transacao);
        const resolvedPriceRange = resolvePriceRangeFromQuery(
            getFiltersPrices1,
            getRouteQueryValue(min, 'min'),
            getRouteQueryValue(max, 'max')
        );

        const boundsSlider = boundsComPrecoEscolhido(getFiltersPrices1, resolvedPriceRange);
        if (filterPrice?.min !== boundsSlider?.min || filterPrice?.max !== boundsSlider?.max) {
            setFilterPrice(boundsSlider);
        }
        if (price[0] !== resolvedPriceRange[0] || price[1] !== resolvedPriceRange[1]) {
            setPrice(resolvedPriceRange);
        }
        
        if (query_type && query_type != "-") {
            const typeTokens = normalizeSegmentForLookup(query_type, true)
                .split(/[+,]/)
                .map((token) => token.trim())
                .filter(Boolean);
            const typeSlugs = segmentosCrusDaUrl(query_type);
            // um por nome (chips, breadcrumb e título sem "Apartamento, Apartamento"); a consulta leva os xarás
            GetOnlyType = umTipoPorNome(formatType?.filter((e: any) => {
                return (
                    typeTokens.includes(normalizeLabelForLookup(e?.label)) ||
                    typeSlugs.some((seg) => segmentoFiltroCasaNome(seg, e?.label, allDataHome?.site?.id))
                );
            }));
            setTypeActual(GetOnlyType ? GetOnlyType : []);
        } else {
            setTypeActual([])
        }

        if (query_city && query_city != "-") {
            const queryCityNormalized = normalizeSegmentForLookup(query_city);
            const citySlugs = segmentosCrusDaUrl(query_city);
            getCity = formatCities.find(
                (v: any) =>
                    normalizeLabelForLookup(v?.label) === queryCityNormalized ||
                    citySlugs.some((seg) => segmentoFiltroCasaNome(seg, v?.label, allDataHome?.site?.id))
            );
            if(getCity){
                setCityActual(getCity);
                const infoDistrict = await district(Number(getCity?.value || -1), origin, codsite1);
                if(infoDistrict){
                    const formatListDistrict = formatSelects(infoDistrict?.bairros);
                    setListDistrict(formatListDistrict);
                    if(query_district && query_district != "-"){
                        const districtTokens = normalizeSegmentForLookup(query_district, true)
                            .split('+')
                            .map((token) => token.trim())
                            .filter(Boolean);
                        const districtSlugs = segmentosCrusDaUrl(query_district);
                        getDistrict = formatListDistrict.filter((v: any) => {
                            return (
                                districtTokens.includes(normalizeLabelForLookup(v?.label)) ||
                                districtSlugs.some((seg) => segmentoFiltroCasaNome(seg, v?.label, allDataHome?.site?.id))
                            );
                        });
                        setDistrictActual(getDistrict ? getDistrict : []);
                    }
                }
            }
        } else {
            setCityActual(null)
            // cs834 (utils/buscaMultiSelecao): com 2+ cidades (`?cidades=`) o caminho não tem cidade —
            // os bairros dele são lidos na união dos bairros dessas cidades (a mesma lista do select).
            const cidadesDaUrl = localMulti ? parseCidadesQuery(router.query?.[CIDADES_QUERY_PARAM]) : [];
            if (cidadesDaUrl.length >= 2 && query_district && query_district != "-") {
                const respostas = await Promise.all(
                    cidadesDaUrl.map((id) => district(id, origin, codsite1).catch(() => null))
                );
                const formatListDistrict = uniaoBairrosDasCidades(respostas, formatCities);
                setListDistrict(formatListDistrict);
                const districtTokens = normalizeSegmentForLookup(query_district, true)
                    .split('+')
                    .map((token) => token.trim())
                    .filter(Boolean);
                const districtSlugs = segmentosCrusDaUrl(query_district);
                setDistrictActual(formatListDistrict.filter((v: any) => (
                    districtTokens.includes(normalizeLabelForLookup(v?.label)) ||
                    districtSlugs.some((seg) => segmentoFiltroCasaNome(seg, v?.label, allDataHome?.site?.id))
                )));
            }
        }
        if (query_company && query_company != '-') {
            // Fazer request pegando aquele nome do condominio
            const companyFormat = normalizeSegmentForLookup(query_company);
            let infoCompany: any = await getCompany(companyFormat, origin, codsite1);
            let buscaPorPrefixo = false;

            // O nome vem do slug, então pontuação do nome real ("Ed. Solar", "Vila / Verde")
            // não sobrevive e o LIKE do backend não acha nada. Tenta de novo pela 1ª palavra
            // e deixa o casamento por slug (abaixo) escolher o empreendimento certo — aqui o
            // "chute" do primeiro da lista NÃO vale, senão filtraria por um vizinho qualquer.
            if (!infoCompany?.empreendimentos?.length) {
                const primeiraPalavra = companyFormat.split(' ').filter(Boolean)[0];
                if (primeiraPalavra && primeiraPalavra !== companyFormat) {
                    infoCompany = await getCompany(primeiraPalavra, origin, codsite1);
                    buscaPorPrefixo = true;
                }
            }

            if (infoCompany?.empreendimentos?.length) {
                const formatCompany = await formatSelects(
                    infoCompany?.empreendimentos
                );
                if (formatCompany?.length > 0) {
                    const companySlugs = segmentosCrusDaUrl(query_company);
                    const exactCompany = formatCompany.find(
                        (company: any) =>
                            normalizeLabelForLookup(company?.label) === companyFormat ||
                            companySlugs.some((seg) => segmentoFiltroCasaNome(seg, company?.label, allDataHome?.site?.id))
                    );
                    const resolvedCompany = exactCompany || (buscaPorPrefixo ? null : formatCompany[0]);

                    if (resolvedCompany) {
                        setCompanyActual({
                            label: resolvedCompany?.label,
                            value: resolvedCompany?.value,
                        });
                    } else {
                        setCompanyActual(0);
                    }
                } else {
                    setCompanyActual(0);
                }
            } else {
                setCompanyActual(0);
            }
        } else {
            setCompanyActual(0);
        }

        if (router.query?.code) {
            setCodeActual(String(router.query?.code).replaceAll("%20"," "));
        } else {
            setCodeActual('')
        }
        if(transacao != undefined && transacao && site?.transacoes){
            setType(JSON.stringify(transacao))
        }else{
            if (query_transacao === 'aluguel') {
                setType('rent');
            } else {
                if(query_transacao === 'venda'){
                    setType('sale');
                } else {
                    setType('temporada');
                }
            }
        }
        setFiltersInitialized(true)
        if(site?.caracteristicas_home || site?.categoria_home || site?.mostrar_data_entrega || hasStateFilter){
            await GetInitialFilters2()
        } else {
            setAutorizaBusca(true)
        }
        } catch (error) {
            warnStorageBootstrap('GetInitialFilters', error);
            resetBootstrapLists();
            setFiltersInitialized(true);
            setAutorizaBusca(true);
        }
    };

    const zeraFiltros = () => {
        setPage(1)
        setCityActual(null)
        setTypeActual([])
        setCaractActual([])
        setDistrictActual([])
        setType("sale")
        setFilters([])
        setAgenciador(0)
        setPrice([filterPrice?.min,filterPrice?.max]);
        setCompanyActual(0)
        setCategoryActual(null)
        setDataEntregaActual([])
        // cs834: as listas (condomínios, categorias e as 2+ cidades) também saem — e as cidades dos modelos novos.
        if(buscaMulti){
            setCondominiosMultiIds([])
            setCategoriasMultiIds([])
        }
        if(localMulti){
            setCidadesMultiIds([])
            setZeraMultiToken((n) => n + 1)
        }
        // cs2065: "Ver todos os imóveis" também tira País e Estado.
        if(filtroPais){
            setPaisActual(null)
            setEstadoActual(null)
            setListCity(allCities)
        }
        // BUSCA POR IA: "Ver todos os imóveis" também tira os mínimos, o "perto" e a faixa.
        if(buscaIaAtiva(estadoBuscaIaRef.current)){
            setEstadoBuscaIa(parametrosBuscaIaVazios())
            setDadosFaixaIa(null)
            if(orderActual?.value === ORDEM_DISTANCIA){
                setOrderActual(renderOrdem())
            }
        }
        setFiltersInitialized(true)
        setAutorizaBusca(true)
    }

    const GetInitial = async (newPage?: boolean) => {
        if (!router.isReady) return;

        const verifyPage = () => {
            if (page) {
                return page;
            }
            return 1;
        };

        const query_type = router.query?.type != '[type]' ? router.query?.type || '-' : '-'
        const query_city = router.query?.city != '[city]' ? router.query?.city || '-' : '-'
        const query_district = router.query?.district != '[district]' ? router.query?.district || '-' : '-'
        const query_company = router.query?.company != '[company]' ? router.query?.company : '-'
        const pageActual = verifyPage();
        let buscou = 0;
        const agenciadorQuery = agenciadorId > 0 ? agenciadorId : (Number(idAgenciador) || 0);

        // MULTI-REGIÃO: com região ativa e SEM cidade explícita escolhida pelo usuário,
        // a busca é restrita às cidades da região (id_cidades). Cidade explícita VENCE.
        const regiaoAtual = regiaoAtivaRef.current;
        const regiaoBusca =
            regiaoAtual && !cityActual?.value && Array.isArray(regiaoAtual?.cidadeIds) && regiaoAtual.cidadeIds.length > 0
                ? regiaoAtual
                : null;
        // MULTI-FILIAIS: precedência ÚNICA (resolveCidadesBusca) —
        // cidades marcadas (2+) > cidade explícita > cidades da filial ativa.
        // O SSR (contagem/noindex) usa a MESMA função, então nunca divergem.
        const cidadesBusca = resolveCidadesBusca({
            cidadesSelecionadas: modoPopupRef.current || localMulti ? cidadesMultiRef.current : [],
            idCidade: cityActual?.value,
            regiao: regiaoBusca,
        });
        const idCidadeBusca = cidadesBusca.idCidade || undefined;
        const idCidadesRegiao: number[] | null = cidadesBusca.idCidades;
        // cs2065: País escolhido SEM estado e SEM cidade ⇒ a busca fica nas cidades daquele país
        // (utils/filtroPais). Com estado, vale o id_estado de sempre; com cidade, a cidade.
        const idCidadesPais =
            filtroPais && paisActual?.value && !estadoActual?.value && !idCidadeBusca && !idCidadesRegiao?.length
                ? idsCidadesDoPais(allCities, listEstados, paisActual.value)
                : [];
        const idCidadesBusca: number[] | null = idCidadesPais.length > 0 ? idCidadesPais : idCidadesRegiao;
        // cs834 (utils/buscaMultiSelecao): 2+ condomínios/categorias marcados vão como LISTA
        // (id_empreendimentos/id_categorias) e na URL; com 0 ou 1, o escalar de sempre.
        const condominiosMulti = buscaMulti ? idsMultiAtivos(condominiosMultiRef.current) : null;
        const categoriasMulti = buscaMulti ? idsMultiAtivos(categoriasMultiRef.current) : null;
        const condominioBusca = condominiosMulti || companyActual?.value;
        const categoriaBusca = categoriasMulti || (categoryActual?.value ? categoryActual?.value : 0);

        const trans = type == "sale" ? "venda" : type == "rent" ? "aluguel" : type == "temporada" ? "temporada" : router.query?.model == 'venda' || router.query?.model == 'aluguel' || router.query?.model == 'temporada' ? router.query?.model : 'venda';
        // Cidade fixa estrita: com CÓDIGO digitado, cidade e bairro saem da busca —
        // senão a cidade fixa esconderia imóvel de outra cidade (utils/condominiosBusca).
        const codigoVenceCidade = buscaCidadeFixaEstrita(allDataHome?.site?.id) && !!codeActual;
        // BUSCA POR IA (utils/buscaIa) — tudo vazio fora dela, e aí as linhas abaixo são as de sempre:
        //  • mínimo da IA só no campo sem número EXATO escolhido na lateral;
        //  • "Mais próximos" só com o ponto (sem ele, `ordenar: distancia` viraria "mais antigos");
        //  • a URL reconstruída (paginar/ordenar) usa o segmento SEGURO, o mesmo do hero, para
        //    nome com "/", "?", "#" não quebrar o caminho no meio da busca.
        const iaAtual = estadoBuscaIaRef.current;
        const iaNaBusca = buscaIaAtiva(iaAtual);
        const minimosIa = minimosIaEfetivos(iaAtual.minimos, filters);
        const ordemBusca = orderActual?.value === ORDEM_DISTANCIA && !iaAtual.perto ? renderOrdem() : orderActual;
        const pertoNaBusca = ordemBusca?.value === ORDEM_DISTANCIA ? iaAtual.perto : null;
        const extrasBuscaIa: ExtrasBuscaIa | undefined =
            temMinimosIa(minimosIa) || pertoNaBusca ? { minimos: minimosIa, perto: pertoNaBusca } : undefined;
        const segmentoDaUrl = iaNaBusca
            ? (label: unknown) => segmentoFiltroSeguro(label, allDataHome?.site?.id)
            : segmentoParaUrl;
        let newPathForm = `/imoveis/${trans}/${
            (codigoVenceCidade ? '-' : (cidadesBusca.origem === 'multi' ? '' : segmentoDaUrl(cityActual?.label))) || '-'
        }/${
            (codigoVenceCidade
                ? '-'
                : districtActual
                    ?.map((e) => segmentoDaUrl(e?.label))
                    ?.join()
                    ?.replaceAll(',', '+')) || '-'
        }/${
            companyActual?.label
                ? segmentoDaUrl(companyActual?.label)
                : '-'
        }/${
            typeActual
                ?.map((e) => segmentoDaUrl(e?.label))
                ?.join()
                ?.replaceAll(',', '+') || '-'
        }${
            codeActual ? `/${codeActual?.replaceAll(' ', '%20')}` : ''
        }`?.replaceAll(' ', '');
        
        if (!window.location.pathname.includes('/novidades')) {
            if(removerAcentos(newPathForm).toLowerCase() != newPath)
                setNewPath(removerAcentos(newPathForm).toLowerCase());

            if(categoryActual?.value || caractActual?.length > 0 || dataEntregaActual?.length > 0 || codsite || id_estado > 0 || (filtroPais && paisActual?.value) || categoria > 0 || area[0] || area[1] || price[0] || price[1] || utm_source || utm_medium || utm_id || utm_campaign || filters.suites_min || filters.dormitorios_min || filters.garagems_min || filters.banheiros_min || openFavoritos || promocao == "1" || agenciadorQuery > 0 || iaNaBusca){
                newPathForm = newPathForm+'?filtros'
                if(price[0] || price[1]){
                    newPathForm = newPathForm+'&min='+price[0]+'&max='+price[1]
                }
                if(area[0] || area[1]){
                    newPathForm = newPathForm+'&area_min='+area[0]+'&area_max='+area[1]
                }
                if(categoryActual?.value){
                    newPathForm = newPathForm+'&categoria='+categoryActual?.value
                } 
                if(filtroPais && paisActual?.value){
                    newPathForm = newPathForm+'&'+PAIS_QUERY_PARAM+'='+paisActual?.value
                }
                if(estadoActual?.value){
                    newPathForm = newPathForm+'&id_estado='+estadoActual?.value
                } else {
                    // cs2065: com filtro de país, o estado da URL já foi resolvido (ou descartado)
                    // em GetInitialFilters2 — repetir o da URL traria de volta o estado que o
                    // visitante acabou de tirar (ou de outro país).
                    if(id_estado > 0 && !filtroPais){
                        newPathForm = newPathForm+'&id_estado='+id_estado
                    }
                }
                if(dataEntregaActual?.length > 0){
                    newPathForm = newPathForm + '&data_entrega='+dataEntregaActual?.map((tip: any) => {return tip?.value}).join(",");
                } else {
                    if(datas_entrega){
                        newPathForm = newPathForm+'&data_entrega='+datas_entrega
                    }
                }
                if(codsite){
                    newPathForm = newPathForm+'&codsite='+codsite
                }
                if(promocao){
                    newPathForm = newPathForm+'&promocao=1'
                }
                if(utm_source){
                    newPathForm = newPathForm+'&utm_source='+utm_source
                }
                if(utm_medium){
                    newPathForm = newPathForm+'&utm_medium='+utm_medium
                }
                if(utm_id){
                    newPathForm = newPathForm+'&utm_id='+utm_id
                }
                if(utm_campaign){
                    newPathForm = newPathForm+'&utm_campaign='+utm_campaign
                }
                if(agenciadorQuery > 0){
                    newPathForm = newPathForm+'&agenciador='+agenciadorQuery
                }
                if(filters.suites_min){
                    newPathForm = newPathForm+'&suites='+qtdParaUrl(filters, 'suites_min')
                }
                if(filters.dormitorios_min){
                    newPathForm = newPathForm+'&dormitorios='+qtdParaUrl(filters, 'dormitorios_min')
                }
                if(filters.garagems_min){
                    newPathForm = newPathForm+'&vagas='+qtdParaUrl(filters, 'garagems_min')
                }
                if(filters.banheiros_min){
                    newPathForm = newPathForm+'&banheiros='+qtdParaUrl(filters, 'banheiros_min')
                }
                // BUSCA POR IA: ia=1, os mínimos e o "perto" continuam na URL ao paginar/ordenar
                // (e na assinatura do cache local — sem eles a busca com "2+ suítes" e a sem
                // colidiriam na mesma chave).
                if(iaNaBusca){
                    const queryIa = queryBuscaIa({ ia: iaAtual.ia, minimos: minimosIa, perto: iaAtual.perto, pertoRotulo: iaAtual.pertoRotulo })
                    if(queryIa){
                        newPathForm = newPathForm+'&'+queryIa
                    }
                }
                if(ordemBusca?.value){
                    newPathForm = newPathForm+'&ordem='+ordemBusca?.value
                }
                if(pageActual){
                    newPathForm = newPathForm+'&pagination='+pageActual
                }
                if(caractActual?.length > 0){
                    newPathForm = newPathForm + '&id_caracteristica='+caractActual?.map((tip: any) => {return tip?.value}).join(",");
                } else {
                    if(caracteristica){
                        newPathForm = newPathForm+'&id_caracteristica='+caracteristica
                    }
                }

                if((favoritosIds.length > 0 || favoritos) && openFavoritos){
                    newPathForm = newPathForm+'&favoritos='+favoritosIds.join(',')
                }
            }
        }

        // MULTI-FILIAIS: 2+ cidades marcadas viajam na URL como ?cidades=<ids> —
        // é o que torna a busca multi-cidade compartilhável e reproduzível no SSR
        // (a cidade única continua no slug do caminho, por compatibilidade e SEO).
        if (cidadesBusca.origem === 'multi') {
            newPathForm =
                newPathForm +
                (newPathForm.includes('?') ? '&' : '?') +
                `${CIDADES_QUERY_PARAM}=${formatCidadesQuery(cidadesBusca.idCidades)}`;
        }
        if (buscaMulti) {
            newPathForm = appendFiltrosMultiQuery(newPathForm, condominiosMulti, categoriasMulti);
        }

        // MULTI-REGIÃO: a região aplicada entra na URL/assinatura da busca (?regiao=)
        // — isola o cache local (ultima_consulta:*) e a assinatura de re-busca da versão
        // sem região, e mantém a URL compartilhável/regionalizável no SSR (?regiao=).
        if (regiaoBusca?.slug && !window.location.pathname.includes('/novidades')) {
            // MULTI-FILIAIS (modo popup): a MATRIZ não entra na URL — ela é o
            // default do tenant e o SSR já resolve nela sem parâmetro nenhum.
            newPathForm = modoPopupRef.current
                ? appendRegiaoQuery(newPathForm, regiaoBusca, regiaoMatrizRef.current?.slug || null)
                : newPathForm + (newPathForm.includes('?') ? '&' : '?') + 'regiao=' + regiaoBusca.slug;
        }

        const normalizedNewPathForm = normalizePath(newPathForm);
        const searchSignature = getSearchSignature(newPathForm);
        const mapSignature = getMapSignature(newPathForm);
        const cacheKey = getSearchCacheKey(newPathForm);
        const lastSearchSignature = getSearchSignature(ultimaConsulta || '');
        let requestId = 0;
        // declarado AQUI (fora do if) p/ o bloco do mapa, mais abaixo, também enxergar o signal.
        let listAbortController: AbortController | null = null;
        // quando a busca usa a query UNIDA (lista+mapa em 1 POST), os marcadores vêm aqui e o
        // bloco do mapa usa direto (sem 2º fetch). Se a query unida falhar, fica null -> fallback.
        let mergedMapData: any = null;

        // Sem a antiga trava `filterPrice?.max > 0`: quando todos os imóveis da transação estão
        // com valor 0 (ex.: cs2561, aluguel só com imóveis sem preço de locação → precos_locacao
        // {0,0}), a busca nunca saía e o else abaixo não desliga o loading → spinner eterno.
        // Com teto 0 a query vai sem filtro de preço (0 é omitido em services/properties.ts).
        if((lastSearchSignature == "" || searchSignature != lastSearchSignature || first || allProperties?.length == 0) && ((companyActual?.value || query_company == "-" || query_company == undefined) &&
        (typeActual?.length > 0 || query_type == '-' || query_type == undefined) &&
        (cityActual?.value > 0 || query_city == '-' || query_city == undefined) &&
        (districtActual.length > 0 || query_district == '-' || query_district == undefined) || filtersInitialized)) {
            if(!filtersInitialized)
                setFiltersInitialized(true)

            setFirst(true)

            // ultimaConsulta NÃO é mais avançado aqui (otimista, antes do fetch). Era a causa do
            // bug do filtro mobile que "às vezes não busca": numa corrida (auto-search + CONCLUÍDO),
            // a busca DESCARTADA pelo isLatestListRequest já tinha avançado a assinatura → a busca
            // sobrevivente via searchSignature==lastSearchSignature e (com first=false) caía no
            // GUARD FAIL sem renderizar. Agora só avança quando a busca REALMENTE commita (abaixo).

            // aborta a busca anterior (lista/mapa) ainda em voo — só o socket; a correção de
            // estado continua por isLatestListRequest. A busca mais recente nunca é abortada.
            if (listAbortRef.current) {
                try { listAbortRef.current.abort(); } catch {}
            }
            listAbortController =
                typeof AbortController !== 'undefined' ? new AbortController() : null;
            listAbortRef.current = listAbortController;

            requestId = beginListRequest(searchSignature)

            let GetFilters
            let getOnlyQuery

            const freshContextCache = getFreshContextSearch(searchSignature);
            if(lastSearchSignature == searchSignature && freshContextCache){
                GetFilters = freshContextCache
                getOnlyQuery = freshContextCache;
            } else {
                const getImo = getCachedSearch(newPathForm);
                if(getImo?.imoveis?.length > 0){
                    GetFilters = getImo
                    getOnlyQuery = getImo;
                } else {
                    // unir lista+mapa em 1 POST quando o tenant tem mapa E o filtro do mapa mudou
                    // (não na paginação). Se a query unida falhar, cai nas funções separadas (fallback).
                    const useMergedMap = !!(site?.mostrar_mapa && site?.mostrar_mapa != undefined && (latestMapSignatureRef.current !== mapSignature));
                    if(promocao == "1"){
                        const promoList = (fn: any) => fn(
                            categoriaBusca,
                            pageActual,
                            idCidadeBusca,
                            districtActual.length > 0
                                ? JSON.stringify(districtActual.map((v) => v?.value))
                                : null,
                            typeActual.length > 0
                                ? JSON.stringify(idsDeTiposParaBusca(idsComXarasPorNome(typeActual.map((v) => v?.value), listType), allDataHome?.tipos))
                                : null,
                            JSON.stringify(codeActual),
                            semPrecoNosFavoritos ? 0 : (type == 'sale'
                                ? Number(price[0])
                                : 0),
                            semPrecoNosFavoritos ? null : (type == 'sale'
                                ? Number(price[1])
                                : null),
                            semPrecoNosFavoritos ? 0 : (type == 'rent'
                                ? Number(price[0])
                                : 0),
                            semPrecoNosFavoritos ? null : (type == 'rent'
                                ? Number(price[1])
                                : null),
                            soFavoritos ? 0 : (type == 'sale' ? 1 : 0),
                            soFavoritos ? 0 : (type == 'rent' ? 1 : 0),
                            condominioBusca,
                            orderActual,
                            qtdParaBusca(filters, 'garagems_min'),
                            qtdParaBusca(filters, 'dormitorios_min'),
                            qtdParaBusca(filters, 'suites_min'),
                            qtdParaBusca(filters, 'banheiros_min'),
                            agenciadorQuery,
                            semPrecoNosFavoritos ? 0 : (type == 'temporada'
                                ? Number(price[0])
                                : 0),
                            semPrecoNosFavoritos ? null : (type == 'temporada'
                                ? Number(price[1])
                                : null),
                            soFavoritos ? 0 : (type == 'temporada' ? 1 : 0),
                            openFavoritos ? apenasArray(favoritosIds) : '',
                            origin,
                            codsite1,
                            listAbortController?.signal,
                            idCidadesBusca
                        );
                        GetFilters = useMergedMap
                            ? await promoList(propertiesFilterPromocaoWithMap)
                            : await promoList(propertiesFilterPromocao);
                        if (useMergedMap) {
                            if (GetFilters?.imoveis_promocao) mergedMapData = GetFilters?.mapa;
                            else GetFilters = await promoList(propertiesFilterPromocao); // fallback
                        }

                        getOnlyQuery = ['Valor', 'Valor'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_promocao
                        : ['Visualizacao', 'Visualizacao'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_promocao
                        : GetFilters?.imoveis_promocao;
                    } else {
                        const buscaList = (fn: any) => fn(
                            categoriaBusca,
                            pageActual,
                            idCidadeBusca,
                            districtActual.length > 0
                                ? JSON.stringify(districtActual.map((v) => v?.value))
                                : null,
                            typeActual.length > 0
                                ? JSON.stringify(idsDeTiposParaBusca(idsComXarasPorNome(typeActual.map((v) => v?.value), listType), allDataHome?.tipos))
                                : null,
                            JSON.stringify(codeActual),
                            semPrecoNosFavoritos ? 0 : (type === 'sale' || type === 'temporada'
                                ? Number(price[0])
                                : 0),
                            semPrecoNosFavoritos ? null : (type === 'sale' || type === 'temporada'
                                ? Number(price[1])
                                : null),
                            semPrecoNosFavoritos ? 0 : (type === 'rent'
                                ? Number(price[0])
                                : 0),
                            semPrecoNosFavoritos ? null : (type === 'rent'
                                ? Number(price[1])
                                : null),
                            soFavoritos ? 0 : (type === 'sale' ? 1 : 0),
                            soFavoritos ? 0 : (type === 'rent' ? 1 : 0),
                            condominioBusca,
                            ordemBusca,
                            qtdParaBusca(filters, 'garagems_min'),
                            qtdParaBusca(filters, 'dormitorios_min'),
                            qtdParaBusca(filters, 'suites_min'),
                            qtdParaBusca(filters, 'banheiros_min'),
                            agenciadorQuery,
                            semPrecoNosFavoritos ? 0 : (type === 'temporada'
                                ? Number(price[0])
                                : 0),
                            semPrecoNosFavoritos ? null : (type === 'temporada'
                                ? Number(price[1])
                                : null),
                            soFavoritos ? 0 : (type === 'temporada' ? 1 : 0),
                            openFavoritos ? apenasArray(favoritosIds) : '',
                            origin,
                            codsite1,
                            caractActual.length > 0
                            ? JSON.stringify(caractActual.map((v) => v?.value))
                            : 0,
                            area[0] >= 0 ? area[0] : 0,
                            area[1] > 0 ? area[1] : 0,
                            0,
                            dataEntregaActual.length > 0
                            ? JSON.stringify(dataEntregaActual.map((v) => v?.value))
                            : 0,
                            estadoActual?.value > 0
                            ? estadoActual?.value
                            : 0,
                            listAbortController?.signal,
                            idCidadesBusca,
                            extrasBuscaIa
                        );
                        GetFilters = useMergedMap
                            ? await buscaList(propertiesFilterWithMap)
                            : await buscaList(propertiesFilter);
                        if (useMergedMap) {
                            if (GetFilters?.imoveis_busca) mergedMapData = GetFilters?.mapa;
                            else GetFilters = await buscaList(propertiesFilter); // fallback
                        }

                        getOnlyQuery = ['Valor', 'Valor'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_busca
                        : ['Visualizacao', 'Visualizacao'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_busca
                        : GetFilters?.imoveis_busca;
                    }
                }
            }

            if (!isLatestListRequest(requestId, searchSignature)) {
                return;
            }

            // Avança a "última consulta" SÓ aqui — quando a busca passou no isLatest pós-fetch e VAI
            // commitar (antes era otimista lá em cima, antes do fetch). Assim uma busca descartada na
            // corrida (auto-search + CONCLUÍDO) não avança a assinatura e não bloqueia a busca
            // sobrevivente no GUARD (fix do "filtro mobile às vezes não atualiza"). Fica antes do
            // router.push p/ manter a supressão do eco de URL.
            if (searchSignature != lastSearchSignature)
                setUltimaConsulta(searchSignature)

            const currentRawPath = currentAsPath || '';
            const currentComparable = getSearchSignature(currentRawPath);
            const initialComparable = initialComparableRef.current || currentComparable;
            const preserveInitial =
                currentRawPath === initialUrlRef.current &&
                searchSignature === initialComparable;

            if (!userActionRef.current) {
                setAllUrl(normalizedNewPathForm);
            } else if (preserveInitial) {
                setAllUrl(normalizedNewPathForm);
            } else if (searchSignature !== currentComparable) {
                // marca que ESTA mudança de URL foi auto-causada → o efeito do currentSearchSignature
                // vai ignorar o eco (não re-roda GetInitialFilters/setAutorizaBusca).
                selfNavSignatureRef.current = searchSignature;
                router.push(normalizedNewPathForm, undefined, { shallow: true, scroll: false });
                setAllUrl(normalizedNewPathForm);
            } else {
                setAllUrl(normalizedNewPathForm);
            }

            if (!isLatestListRequest(requestId, searchSignature)) {
                return;
            }

            setSearchContextCache(getOnlyQuery)
            if (getOnlyQuery?.imoveis?.length > 0) {
                setWithTTL(cacheKey, getOnlyQuery, LIST_CACHE_TTL);
                buscou =1;
                setNaoEncontrou(false)
                setLoading(false)
                setAllProperties(getOnlyQuery?.imoveis);
                setQtd(getOnlyQuery?.count);
                if (typeValidation) {
                    if(codeActual?.length >= 2) {
                        if(typeValidation != 'por código'){
                            setTypeValidation('por código');
                        }
                    }else{
                        if (type === 'sale') {
                            if(typeValidation != 'à venda'){
                                setTypeValidation('à venda');
                            }
                        }
                        if (type === 'rent') {
                            if(typeValidation != 'para alugar'){
                                setTypeValidation('para alugar');
                            }
                        }
                        if (type === 'temporada') {
                            if(typeValidation != 'para Temporada'){
                                setTypeValidation('para Temporada');
                            }
                        }
                    }
                } else {
                    if(typeValidation != renderOnlyTextFilters1()){
                        setTypeValidation(renderOnlyTextFilters1());
                    }
                }
            } else {
                // 0 resultados é estado FINAL (mostra "nenhum imóvel encontrado"), não
                // "carregando". Deixar loading=true aqui (bug antigo) prendia a página em
                // spinner + re-disparo infinito quando a busca legitimamente não tinha match.
                latestMapSignatureRef.current = ''
                setNaoEncontrou(true)
                setQtd(0)
                setLoading(false)
                setAllProperties([])
                setAllPropertiesMapa([])
            }
        } else {
            latestMapSignatureRef.current = ''
            if (allProperties?.length > 0) {
                setLoading(false);
                return;
            }
            setAllProperties([]);
            setAllPropertiesMapa([])
            setQtd(0);

            if(codeActual?.length >= 2) {
                if(typeValidation != 'por código'){
                    setTypeValidation('por código');
                }
            }else{
                if (type === 'sale') {
                    if(typeValidation != 'à venda'){
                        setTypeValidation('à venda');
                    }
                }
                if (type === 'rent') {
                    if(typeValidation != 'para alugar'){
                        setTypeValidation('para alugar');
                    }
                }
                if (type === 'temporada') {
                    if(typeValidation != 'para Temporada'){
                        setTypeValidation('para Temporada');
                    }
                }
            }

            if (newPage && typeof newPage === 'boolean' && page > 1) {
                setPage(page - 1);
                // alert('Não há mais imóveis nas próximas páginas');
            }
        }
        if(site?.mostrar_mapa && site?.mostrar_mapa != undefined && buscou == 1) {
            // assinatura SEM paginação: paginar não re-busca o mapa (marcadores são sempre page:1).
            const shouldFetchMap = latestMapSignatureRef.current !== mapSignature;
            if (!shouldFetchMap) {
                return;
            }

            // veio junto da lista (query UNIDA, 1 POST) → usa direto, sem 2º fetch.
            if (mergedMapData) {
                if (!isLatestListRequest(requestId, searchSignature)) {
                    return;
                }
                latestMapSignatureRef.current = mapSignature;
                setAllPropertiesMapa(mergedMapData?.count > 0 ? (mergedMapData?.imoveis || []) : []);
                return;
            }

            let GetPropertiesMap
            if(promocao == "1"){
                GetPropertiesMap = await propertiesMapaPromocao(
                    categoriaBusca,
                    1,
                    idCidadeBusca,
                    districtActual.length > 0
                        ? JSON.stringify(districtActual.map((v) => v?.value))
                        : null,
                    typeActual.length > 0
                        ? JSON.stringify(idsDeTiposParaBusca(idsComXarasPorNome(typeActual.map((v) => v?.value), listType), allDataHome?.tipos))
                        : null,
                    JSON.stringify(codeActual),
                    type === 'sale'
                        ? Number(price[0])
                        : 0,
                    type === 'sale'
                        ? Number(price[1])
                        : null,
                    type === 'rent'
                        ? Number(price[0])
                        : 0,
                    type === 'rent'
                        ? Number(price[1])
                        : null,
                    type === 'sale' ? 1 : 0,
                    type === 'rent' ? 1 : 0,
                    condominioBusca,
                    orderActual,
                    qtdParaBusca(filters, 'garagems_min'),
                    qtdParaBusca(filters, 'dormitorios_min'),
                    qtdParaBusca(filters, 'suites_min'),
                    qtdParaBusca(filters, 'banheiros_min'),
                    agenciadorQuery,
                    type === 'temporada' ? 1 : 0,
                    100,
                    origin,
                    codsite1,
                    listAbortController?.signal,
                    idCidadesBusca
                );

                if (!isLatestListRequest(requestId, searchSignature)) {
                    return;
                }

                latestMapSignatureRef.current = mapSignature;
                if(GetPropertiesMap?.imoveis_promocao?.count > 0){
                    setAllPropertiesMapa(GetPropertiesMap?.imoveis_promocao?.imoveis)
                } else {
                    setAllPropertiesMapa([])
                }
            } else {
                GetPropertiesMap = await propertiesMapa(
                    categoriaBusca,
                    1,
                    idCidadeBusca,
                    districtActual.length > 0
                        ? JSON.stringify(districtActual.map((v) => v?.value))
                        : null,
                    typeActual.length > 0
                        ? JSON.stringify(idsDeTiposParaBusca(idsComXarasPorNome(typeActual.map((v) => v?.value), listType), allDataHome?.tipos))
                        : null,
                    JSON.stringify(codeActual),
                    type === 'sale'
                        ? Number(price[0])
                        : 0,
                    type === 'sale'
                        ? Number(price[1])
                        : null,
                    type === 'rent'
                        ? Number(price[0])
                        : 0,
                    type === 'rent'
                        ? Number(price[1])
                        : null,
                    type === 'sale' ? 1 : 0,
                    type === 'rent' ? 1 : 0,
                    condominioBusca,
                    ordemBusca,
                    qtdParaBusca(filters, 'garagems_min'),
                    qtdParaBusca(filters, 'dormitorios_min'),
                    qtdParaBusca(filters, 'suites_min'),
                    qtdParaBusca(filters, 'banheiros_min'),
                    agenciadorQuery,
                    type === 'temporada' ? 1 : 0,
                    100,
                    origin,
                    codsite1,
                    listAbortController?.signal,
                    idCidadesBusca,
                    extrasBuscaIa
                );

                if (!isLatestListRequest(requestId, searchSignature)) {
                    return;
                }

                latestMapSignatureRef.current = mapSignature;
                if(GetPropertiesMap?.imoveis?.count > 0){
                    setAllPropertiesMapa(GetPropertiesMap?.imoveis?.imoveis)
                } else {
                    setAllPropertiesMapa([])
                }
            }
        }
    };

    const applyFilter = () => {
        setLoading(true);
        if(filtersInitialized){
            void GetInitial();
        }
        setActiveLargeFilter(false);
    };

    const GetAllCompany = async (nameCompany = '', requestId?: number) => {
        const infoCompany = await getCompany(nameCompany, origin, codsite1);

        if (requestId && latestCompanyRequestRef.current !== requestId) return;

        const companyOptions = buildCompanyOptions({
            ...(infoCompany || {}),
            empreendimentos: filtrarCondominiosCidadeFixa(
                infoCompany?.empreendimentos,
                allDataHome?.site?.id,
                allDataHome?.site?.cidade_busca,
            ),
        });
        setAllCompany(companyOptions);
        localStorage.setItem(condosStorageKey, JSON.stringify(companyOptions));
    };

    const concatLabels = (value: Array<any>) => {
        if (value?.length === 1) {
            return `${value[0]?.label}`;
        }
        if (value?.length === 2) {
            return `${value[0]?.label} e ${value[1]?.label}`;
        }
        if (value?.length >= 3) {
            return `${value[0]?.label}, ${value[1]?.label} e ${value[2]?.label}`;
        }
        return '';
    };

    const renderTextFilters = () => {
        let aux = ""
        if(filters.dormitorios_min && filters.dormitorios_min != undefined){
            if(filters.dormitorios_min == "1" && !temListaQtd(filters, 'dormitorios_min'))
                aux = " com 1 dormitório"
            else 
                aux = ` com ${qtdTexto(filters, 'dormitorios_min')} dormitórios`
        } else {
            if(filters.suites_min && filters.suites_min != undefined){
                if(filters.suites_min == "1" && !temListaQtd(filters, 'suites_min'))
                    aux = " com 1 suíte"
                else 
                    aux = ` com ${qtdTexto(filters, 'suites_min')} suítes`
            } else {
                if(filters.banheiros_min && filters.banheiros_min != undefined){
                    if(filters.banheiros_min == "1" && !temListaQtd(filters, 'banheiros_min'))
                        aux = " com 1 banheiro"
                    else 
                        aux = ` com ${qtdTexto(filters, 'banheiros_min')} banheiros`
                } else {
                    if(filters.garagems_min && filters.garagems_min != undefined){
                        if(filters.garagems_min == "1" && !temListaQtd(filters, 'garagems_min'))
                            aux = " com 1 vaga"
                        else 
                            aux = ` com ${qtdTexto(filters, 'garagems_min')} vagas`
                    }
                }
            } 
        }
        if(promocao == "1"){
            if(allProperties?.length == 0){
                return (
                    <>
                        <h1 className={styles.qtd} style={{color: cor_detalhes}}>{tituloLarissa(`Imóveis em Promoção`)}</h1>
                        {renderSeoIntro()}
                    </>
                );
            }

            return (
                <>
                    <h1 className={styles.qtd} style={{color: cor_detalhes}}>{tituloLarissa(isNovember ? `${qtd} Black November` : `${qtd} Imóveis em Promoção`)}</h1>
                    {renderSeoIntro()}
                </>
            );
        }
        if(openFavoritos){
            return (
                <h1 className={styles.qtd} style={{color: cor_detalhes}}>{tituloLarissa(`${
                    favoritosIds.length
                } ${favoritosIds.length > 1 ? 'Imóveis Favoritos' : 'imóvel Favorito'}`)}</h1>
            );
        }
        if (companyActual) {
            return (
                <>
                    <h1 className={styles.qtd} style={{color: cor_detalhes}}>{tituloLarissa(`${companyActual?.label} ${cityActual?.label ? `em ${cityActual?.label}` : ''}`, aux)}</h1>
                    {renderSeoIntro()}
                    <h2 className={styles.qtd1} style={{color: cor_detalhes}}>
                        <span data-nosnippet>{`${qtd || 0} ${qtd > 1 ? 'Encontrados' : 'Encontrado'}`}</span>
                    </h2>
                </>
            );
        }
        if (typeValidation && !loading) {
            return (
                <>
                <h1 className={styles.qtd} style={{color: cor_detalhes}}>
                    {tituloLarissa(tituloListagemDoSite(site, `${
                        site?.id != 2034
                        ?   typeActual?.length > 0
                            ?   qtd > 1
                                ?   concatLabels(typeActual)
                                    .replaceAll("Casas", "Casa")
                                    .replaceAll("Terrenos", "Terreno")
                                    .replaceAll("Apartamentos", "Apartamento")
                                    .replaceAll("Sobrados", "Sobrado")
                                    .replaceAll("Coberturas", "Cobertura")
                                    .replaceAll("Casa", "Casas")
                                    .replaceAll("Terreno", "Terrenos")
                                    .replaceAll("Apartamento", "Apartamentos")
                                    .replaceAll("Sobrado", "Sobrados")
                                    .replaceAll("Cobertura", "Coberturas")
                                :   concatLabels(typeActual)
                            : qtd > 1
                                ?   'Imóveis'
                                :   'Imóvel'
                        :   typeActual?.length > 0
                            ?   concatLabels(typeActual)
                            :   qtd > 1
                                ? 'Imóveis'
                                : 'Imóvel'
                    } ${categoryActual?.value ? categoryActual?.label : ''} ${typeValidation} ${
                        districtActual?.length > 0 ? concatLabels(districtActual) : ''
                    } ${cityActual?.label ? `em ${cityActual?.label}` : ''}`, aux), aux)}
                </h1>
                {renderSeoIntro()}
                <h2 className={styles.qtd1} style={{color: cor_detalhes}}>
                    <span data-nosnippet>{`${site?.id != 1990 ? (qtd || 0) : ''} ${qtd > 1 ? 'Encontrados' : 'Encontrado'}`}</span>
                </h2>
              </>
            );
        }
        if (!typeValidation && !loading) {
            return (
                <>
                    <h1 className={styles.qtd} style={{color: cor_detalhes}}>{tituloLarissa('Empreendimentos', aux)}</h1>
                    <h2 className={styles.qtd1} style={{color: cor_detalhes}}>
                        <span data-nosnippet>{`${qtd || ""} ${qtd > 1 ? 'Encontrados' : 'Encontrado'}`}</span>
                    </h2>
                </>
            );
        }
        return null;
    };

    const capitalizeFirstLetter = (text: string) => {
        if (!text) return text;
        return text.charAt(0).toUpperCase() + text.slice(1);
      };

    const renderOnlyTextFilters = () => {
        let aux = ""
        if(dormitorios && dormitorios != undefined){
            if(dormitorios == "1")
                aux = " com 1 dormitório"
            else 
                aux = ` com ${qtdTextoDaUrl(dormitorios)} dormitórios`
        } else {
            if(suites && suites != undefined){
                if(suites == "1")
                    aux = " com 1 suíte"
                else 
                    aux = ` com ${qtdTextoDaUrl(suites)} suítes`
            } else {
                if(banheiros && banheiros != undefined){
                    if(banheiros == "1")
                        aux = " com 1 banheiro"
                    else 
                        aux = ` com ${qtdTextoDaUrl(banheiros)} banheiros`
                } else {
                    if(vagas && vagas != undefined){
                        if(vagas == "1")
                            aux = " com 1 vaga"
                        else 
                            aux = ` com ${qtdTextoDaUrl(vagas)} vagas`
                    }
                }
            } 
        }
        const resposta = currentAsPath.split("/")
        if(resposta[7]){
            return `Imóvel cod: ${resposta[7]}`
        }
        if(resposta[5] && resposta[5] != "-"){
            return `${decodeURIComponent(resposta[5].replaceAll("-"," "))} ${resposta[3] && resposta[3] != "-" ? ` em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}` : ""}${aux}`
        }

        let resposta_tipo = []
        if(resposta[6])
            resposta_tipo = resposta[6].split("?")
        if(resposta_tipo[0] != "-" && resposta_tipo[0]){
            if(resposta[3] && resposta[3] != "-"){
                if(resposta[2] == "venda"){
                    return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casas", "Casa").replaceAll("Casa", "Casas").replaceAll("Terrenos", "Terreno").replaceAll("Terreno", "Terrenos").replaceAll("Apartamentos", "Apartamento").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrados", "Sobrado").replaceAll("Sobrado", "Sobrados").replaceAll("Coberturas", "Cobertura").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} à venda em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                } else {
                    if(resposta[2] == "aluguel"){
                        return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casas", "Casa").replaceAll("Casa", "Casas").replaceAll("Terrenos", "Terreno").replaceAll("Terreno", "Terrenos").replaceAll("Apartamentos", "Apartamento").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrados", "Sobrado").replaceAll("Sobrado", "Sobrados").replaceAll("Coberturas", "Cobertura").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para alugar em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                    }
                    if(resposta[2] == "temporada"){
                        return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casas", "Casa").replaceAll("Casa", "Casas").replaceAll("Terrenos", "Terreno").replaceAll("Terreno", "Terrenos").replaceAll("Apartamentos", "Apartamento").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrados", "Sobrado").replaceAll("Sobrado", "Sobrados").replaceAll("Coberturas", "Cobertura").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para temporada em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                    }
                    return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casas", "Casa").replaceAll("Casa", "Casas").replaceAll("Terrenos", "Terreno").replaceAll("Terreno", "Terrenos").replaceAll("Apartamentos", "Apartamento").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrados", "Sobrado").replaceAll("Sobrado", "Sobrados").replaceAll("Coberturas", "Cobertura").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} em ${site?.Dados.cidade ? decodeURIComponent(site?.Dados.cidade) : allCities[0]?.label}${aux}`
                }
            }
            return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casas", "Casa").replaceAll("Casa", "Casas").replaceAll("Terrenos", "Terreno").replaceAll("Terreno", "Terrenos").replaceAll("Apartamentos", "Apartamento").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrados", "Sobrado").replaceAll("Sobrado", "Sobrados").replaceAll("Coberturas", "Cobertura").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para ${resposta[2]}${aux}`
        }
        if(resposta[3] && resposta[3] != "-"){
            if(resposta[2] == "venda"){
                return `Imóveis à venda em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
            } else {
                if(resposta[2] == "aluguel"){
                    return `Imóveis para alugar em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                }
                if(resposta[2] == "temporada"){
                    return `Imóveis para temporada em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                }
                return `Imóveis em ${site?.Dados.cidade ? decodeURIComponent(site?.Dados.cidade) : allCities[0]?.label}${aux}`
            }
        }
        return `Imóveis para ${resposta[2] ? resposta[2] : 'venda'}${aux}`
    };

    const registerSearch = async (searchParams = {}) => {
        // Dedup com o Search de BROWSER (Frente A grava o eventId no clique do botão Buscar).
        // Consumo ÚNICO: lê e REMOVE a chave; só reusa o eventId se recente (<60s). Se não
        // existir/expirado, o CAPI segue idêntico ao atual (sem event_id).
        let searchEventId: string | undefined;
        try {
            const raw = sessionStorage.getItem('meta:searchEventId');
            if (raw) {
                sessionStorage.removeItem('meta:searchEventId');
                const parsed = JSON.parse(raw);
                if (parsed?.id && typeof parsed?.at === 'number' && Date.now() - parsed.at < 60000) {
                    searchEventId = parsed.id;
                }
            }
        } catch {}

        if (typeof window === 'undefined') return;
        if (!resolvePixelId(site?.fb_id_pixel, site?.pixel_facebook_head)) return;
        if (typeof navigator !== 'undefined' && !navigator.onLine) return;

        // Avoid repeated retries for the same search in a short interval.
        const requestKey = `${getSearchSignature(currentAsPath || '')}|${JSON.stringify(searchParams || {})}`;
        const now = Date.now();
        const lastRequest = searchEventRef.current;
        if (lastRequest?.key === requestKey && now - lastRequest.at < 15000) {
            return;
        }
        searchEventRef.current = { key: requestKey, at: now };

        // eventId: reusa o do clique de browser (dedup Pixel×CAPI) se recente; senão gera um novo.
        const eventId = searchEventId || genMetaEventId();
        // CAPI via /api/meta-capi: token/pixel resolvidos server-side por host; IP + User-Agent +
        // _fbp/_fbc coletados no servidor/helper. custom_data = filtros da busca atuais.
        sendMetaCapiEvent({
            site,
            eventName: 'Search',
            eventId,
            customData: { ...searchParams },
        });
    };
    function debounce<F extends (..._args: any[]) => void>(fn: F, delay: number) {
        let timer: ReturnType<typeof setTimeout> | null = null;
        return (...args: Parameters<F>) => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => fn(...args), delay);
        };
    }

     const renderRodape = () => {
        // REGISTRY: variante nova de rodapé ANTES do switch legado — o lookup devolve
        // undefined para os modelos 1-5, então o diff nos ~300 sites é nulo.
        const RodapeNovo = NEW_RODAPE[Number(site?.rodape)];
        if (RodapeNovo) {
            return (
                <RodapeNovo
                    site={site}
                    allCities={allCities}
                    allCitiesTipes={allDataHome?.tipos}
                    codsite={codsite2}
                    origin={origin}
                    isMobile={isMobile1}
                    allRodape={allDataHome?.rodape}
                    favorito={favorito}
                />
            );
        }

        switch (site?.rodape) {
            case 1:
                return (
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                    </motion.div>
                );
            case 2:
                return (
                    <AboutPieces allRodape={allDataHome?.rodape} site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1}/>
                );
            case 3:
                return (
                    <AboutPieces2 site={site} allRodape={allDataHome?.rodape}/>
                );
            case 4:
                return (
                    <MegaFooter
                        site={site}
                        allCities={allCities}
                        codsite={codsite2}
                        origin={origin}
                        isMobile={isMobile1}
                        favorito={favorito}
                        allRodape={allDataHome?.rodape}
                        fallback={<AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>}
                    />
                );
            case 5:
                return (
                    <EditorialFooter
                        site={site}
                        allCities={allCities}
                        codsite={codsite2}
                        origin={origin}
                        isMobile={isMobile1}
                        favorito={favorito}
                        allRodape={allDataHome?.rodape}
                        fallback={<AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>}
                    />
                );
            default:
            return (
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                </motion.div>
            );
        }
    }

    const debouncedGetInitial = useCallback(
        debounce(() => {
            setNaoEncontrou(false);
            const pathNow = getSearchSignature(currentAsPath || '');
            const hasContextCache = !!getFreshContextSearch(pathNow);
            const hasStorageCache =
                !hasContextCache &&
                typeof window !== 'undefined' &&
                !!getCachedSearch(currentAsPath || '')?.imoveis?.length;

            if (!hasContextCache && !hasStorageCache) {
                setLoading(true);
            }
            GetInitial();
            void registerSearch({
                content_category: renderOnlyTextFilters() || 'Busca de imóveis',
                currency: 'BRL',
                search_string: router.query?.city || "-",
                property_type: router.query?.type || "-",
                city: router.query?.city || "-",
                neighborhood: router.query?.district || "-"
            });
        }, 400),[autorizaBusca, filtersInitialized, currentAsPath, getOnlyQuery1, ultimaConsulta]
    );

    useEffect(() => {
        if (!router.isReady) return;

        const currentComparable = getSearchSignature(currentAsPath || '');
        const ultimaComparable = getSearchSignature(ultimaConsulta || '');
        if ((currentComparable !== ultimaComparable) && ultimaConsulta && filtersInitialized) {
            GetInitialFilters();
        }
    }, [router.isReady, currentAsPath]);

    useEffect(() => {
        if(router.isReady && filtersInitialized && autorizaBusca){
            setAutorizaBusca(false)
            debouncedGetInitial();
        }
    }, [autorizaBusca, filtersInitialized, router.isReady, debouncedGetInitial]);

    // MULTI-REGIÃO: mudou a região ativa (seletor do topo / cookie reconciliado
    // pós-mount) → re-dispara a busca. Pula a 1ª execução (a busca inicial normal
    // já roda com a região corrente via regiaoAtivaRef).
    const regiaoSlugBusca = regiaoAtiva?.slug || '';
    const prevRegiaoSlugRef = useRef<string | null>(null);
    useEffect(() => {
        if (prevRegiaoSlugRef.current === null) {
            prevRegiaoSlugRef.current = regiaoSlugBusca;
            return;
        }
        if (prevRegiaoSlugRef.current === regiaoSlugBusca) return;
        prevRegiaoSlugRef.current = regiaoSlugBusca;
        if (router.isReady && filtersInitialized) {
            setAutorizaBusca(true);
        }
    }, [regiaoSlugBusca, filtersInitialized, router.isReady]);


    // BUSCA POR IA: escolher o número EXATO na lateral (ex.: Suítes 3) substitui o mínimo da IA
    // daquele campo — o "2+ suítes" sai do chip e da URL. Sem mínimo da IA, devolve o MESMO
    // estado (nenhuma renderização a mais na listagem manual).
    useEffect(() => {
        setEstadoBuscaIa((atual) => {
            if (!temMinimosIa(atual.minimos)) return atual;
            const efetivos = minimosIaEfetivos(atual.minimos, filters);
            const mudou = MINIMOS_BUSCA_IA.some((m) => efetivos[m.campo] !== atual.minimos[m.campo]);
            return mudou ? { ...atual, minimos: efetivos } : atual;
        });
    }, [filters?.suites_min, filters?.dormitorios_min, filters?.garagems_min, filters?.banheiros_min]);

    const chipsMinimosIa = MINIMOS_BUSCA_IA
        .filter((m) => estadoBuscaIa.minimos[m.campo] > 0)
        .map((m) => ({ campo: m.campo, rotulo: rotuloMinimoIa(m.campo, estadoBuscaIa.minimos[m.campo]) }));
    const removerMinimoBuscaIa = (campo: string) => {
        setEstadoBuscaIa((atual) => ({ ...atual, minimos: { ...atual.minimos, [campo as CampoMinimoIa]: 0 } }));
    };
    const fecharFaixaBuscaIa = () => {
        setDadosFaixaIa(null);
        // fechou, não volta ao reabrir esta busca (voltar do imóvel)
        salvarFaixaBuscaIa(currentAsPath, null);
    };

    useEffect(() => {
        const requestId = latestCompanyRequestRef.current + 1;
        latestCompanyRequestRef.current = requestId;
        const companySearch = String(companyInputActual || '').trim();

        if (!companySearch) return;

        const timeOutId = setTimeout(async () => {
            await GetAllCompany(companySearch, requestId);
        }, 600);

        return () => clearTimeout(timeOutId);
    }, [companyInputActual, codsite1, condosStorageKey, origin]);

    return (
        <div className={`${styles.container}${atelier ? ` ${atInterna.interna}` : ''}${coresAP ? ` ${styles.lista_ap}` : ''}${larissa ? ` ${styles.lista_lr}` : ''}${metropole ? ` ${styles.lista_mt}` : ''}${internacional ? ` ${styles.lista_in} ${inInterna.interna}` : ''}${norte ? ` ${styles.lista_nt} ${ntInterna.interna}` : ''}${campo ? ` ${styles.lista_cp} ${cpInterna.interna}` : ''}`} style={{...estiloRaiz, ...(atelier ? varsAtelier(site) : {}), ...(aurora ? varsAurora(site) : {}), ...(panorama ? varsPanorama(site) : {}), ...(larissa ? varsLarissaInterna(site) : {}), ...(metropole ? varsMetropoleInterna(site) : {}), ...(varsInternacionalPagina(site) || {}), ...(varsNortePagina(site) || {}), ...(varsCampoPagina(site) || {}), ...varsListagemAP(coresAP)}} data-modelo={horizonte ? 'horizonte' : aurora ? 'aurora' : panorama ? 'panorama' : larissa ? 'larissa' : metropole ? 'metropole' : internacional ? 'internacional' : norte ? 'norte' : campo ? 'campo' : undefined}>
            <Head>
                {/* cs2586 (gate utils/seoContextoListagem): título da cidade só na URL só da cidade; bairro/tipo →
                    título da busca; condomínio → meta_title dele e depois o da busca. Fora do gate: o de sempre. */}
                <title>{temSeoContextoListagem(site)
                    ? tituloListagemPorContexto(currentAsPath, {
                        tituloCidade: seoCidade?.titulo,
                        tituloBusca: imoveisSeo?.title || (renderOnlyTextFilters() ? capitalizeFirstLetter(renderOnlyTextFilters()) : site?.titulo),
                        empreendimento: init_props?.seoEmpreendimentoListagem,
                    })
                    : seoCidade?.titulo || imoveisSeo?.title || (renderOnlyTextFilters() ? capitalizeFirstLetter(renderOnlyTextFilters()) : site?.titulo)}</title>
                {/* Busca com 0 imóveis: se NÃO há sugestões de carrossel, sai do índice (evita soft 404);
                    se HÁ imóveis do carrossel, a página tem conteúdo útil → mantém index (pedido Daniel).
                    Sobrescreve o robots do _app via key; a página renderiza depois, então vence. */}
                {/* Busca por IA "perto de…" (?perto=): lista ordenada por distância de um ponto —
                    não é página para o índice. Vem da URL, então sai já no HTML do SSR. */}
                {buscaIaDaUrl.perto ? (
                    <meta name="robots" content="noindex, follow" key="robots" />
                ) : naoEncontrou ? (
                    <meta name="robots" content={emptyStateSuggestions.length > 0 ? "index, follow" : "noindex, follow"} key="robots" />
                ) : null}
                {site?.url_icon && (
                    <link rel="icon" type="image/x-icon" href={site.url_icon} />
                )}
            </Head>
            <ImoveisSchema
                imoveis={allProperties}
                site={site}
                domain={site?.site ? `https://${site.site}` : (init_props?.prodOrigin ? `https://${init_props.prodOrigin}` : '')}
                asPath={currentAsPath}
                faq={seoCidadeFaq}
            />
            <PopUpComponent site={site}/>
            <WhatsAppComponent site={site} />
            { favorito?.length > 0 ?
                <FavoritosComponent site={site} favorito={favorito} setAuxiliar={setFiltersInitialized} setAutorizaBusca={setAutorizaBusca} compartilhar={openFavoritos} setOpenFavoritos={setOpenFavoritos} zeraFiltros={zeraFiltros}/>
            : null }
            <WelcomePiecesCompany
                site={site}
                routes={initialFlow}
                rotulos={{ ...init_props?.rotulosHifen, ...rotulosHifen(
                    [
                        cityActual?.label,
                        ...(Array.isArray(districtActual) ? districtActual.map((e: any) => e?.label) : []),
                        companyActual?.label,
                        ...(Array.isArray(typeActual) ? typeActual.map((e: any) => e?.label) : []),
                        ...(Array.isArray(allDataHome?.cidades) ? (allDataHome?.cidades as any[]).map((c: any) => c?.nome) : []),
                    ],
                    allDataHome?.site?.id
                ) }}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito}
                bannerListagem={urlBannerListagem}
                props={allDataHome}
            />
            <ListPiecesProperties
                allProperties={allProperties}
                setAllProperties={setAllProperties}
                site={site}
                disableEntryMotion={disableEntryMotion}
                page={page}
                area={area}
                first={first}
                setAutorizaBusca={setAutorizaBuscaFromUser}
                allViewProperties={allViewProperties}
                setArea={setArea}
                setPage={setPage}
                searchList={GetInitial}
                qtd={qtd}
                filtersInitialized={filtersInitialized}
                typeValidation={typeValidation}
                typeActual={typeActual}
                setTypeActual={setTypeActual}
                districtActual={districtActual}
                setDistrictActual={setDistrictActual}
                companyActual={companyActual}
                setCompanyActual={setCompanyActual}
                cityActual={cityActual}
                setCityActual={setCityActual}
                cidadesSeed={cidadesSeedIds}
                onCidadesMulti={setCidadesMultiIds}
                buscaMulti={buscaMulti}
                localMulti={localMulti}
                condominiosSeed={condominiosSeedIds}
                categoriasSeed={categoriasSeedIds}
                onCondominiosMulti={setCondominiosMultiIds}
                onCategoriasMulti={setCategoriasMultiIds}
                zeraMultiToken={zeraMultiToken}
                codeActual={codeActual}
                setCodeActual={setCodeActual}
                orderActual={orderActual}
                setOrderActual={setOrderActual}
                price={price}
                setPrice={setPrice}
                filterPrice={filterPrice}
                setFilterPrice={setFilterPrice}
                listCity={listCity}
                listType={listTypeSelect}
                listCompany={allCompany}
                categoryActual={categoryActual}
                setCategoryActual={setCategoryActual}
                setEstadoActual={setEstadoActual}
                estadoActual={estadoActual}
                listEstados={listEstados}
                listPaises={listPaises}
                paisActual={paisActual}
                setPaisActual={setPaisActual}
                allCities={allCities}
                setListCity={setListCity}
                listCategory={listCategory}
                listDatas={listDatas}
                dataEntregaActual={dataEntregaActual}
                setDataEntregaActual={setDataEntregaActual}
                listCaract={listCaracteristicas}
                caractActual={caractActual}
                setCaractActual={setCaractActual}
                type={type}
                setType={setType}
                listDistrict={listDistrict}
                setListDistrict={setListDistrict}
                filters={filters}
                setFilters={setFilters}
                qtdMulti={qtdMulti}
                applyFilter={applyFilter}
                activeLargeFilter={activeLargeFilter}
                setActiveLargeFilter={setActiveLargeFilter}
                companyInputActual={companyInputActual}
                setCompanyInputActual={setCompanyInputActual}
                loading={loading}
                setLoading={setLoading}
                renderTextFilters={renderTextFilters}
                agenciador={idAgenciador}
                setAgenciador={setAgenciador}
                allPropertiesMapa={allPropertiesMapa}
                favorito={favorito || []}
                openFavoritos={openFavoritos}
                setOpenFavoritos={setOpenFavoritos}
                naoEncontrou={naoEncontrou}
                zeraFiltros={zeraFiltros}
                emptyStateSuggestions={emptyStateSuggestions}
                setFavorito={setFavorito}
                allUrl={allUrl}
                origin={origin}
                codsite={codsite1}
                codsite2={codsite}
                valores={valores}
                faixaBuscaIa={
                    estadoBuscaIa.ia && dadosFaixaIa ? (
                        <FaixaBuscaIa site={site} dados={dadosFaixaIa} onFechar={fecharFaixaBuscaIa} />
                    ) : undefined
                }
                opcaoOrdemBuscaIa={
                    estadoBuscaIa.perto
                        ? { label: rotuloOrdemDistancia(estadoBuscaIa.pertoRotulo), value: ORDEM_DISTANCIA }
                        : null
                }
                minimosBuscaIa={chipsMinimosIa}
                onRemoverMinimoBuscaIa={chipsMinimosIa.length ? removerMinimoBuscaIa : undefined}
            />
            { renderSeoCidadeRodape() }
            { renderRodape() }
        </div>
    );
};

export default Properties;
